/* SES Palma · portal de clientes mayoristas (/pages/b2b-cuenta).
   Rutas por hash: #/ resumen · #/pedidos · #/pedidos/<id> · #/analisis (ses-b2b-analytics.js) · #/documentos · #/tarifa · #/datos · #/admin · #/reset
   Todo se pide a Supabase con la sesión del comprador (RLS) y vive en memoria. */
(function () {
  'use strict';
  const B = window.SESB2B;
  const ROOT = document.getElementById('ses-portal');
  if (!B || !ROOT) return;
  const MAIN = ROOT.querySelector('#bpMain');
  const NAV = ROOT.querySelector('#bpNav');
  const CFG = window.SES_B2B_CONFIG || {};
  const ORDER_URL = CFG.orderUrl || '/pages/venta-wholesale';
  const SEASON = CFG.season || 'SS27';
  // misma clave que la página de pedidos (basketKey en ses-pedidos.js): usuario + empresa + temporada
  const basketKey = (companyId) => `ses_order_draft_v1:${S.session && S.session.user ? S.session.user.id : 'anon'}:${companyId || S.companyId}:${SEASON}`;
  const HANDOFF_KEY = 'ses_b2b_handoff';
  const { esc, ICON } = B;
  const t = B.t;
  // Aviso de datos de facturación: encima del contenido, fuera de MAIN (que se repinta en cada vista).
  const BILL_SLOT = (() => {
    const col = document.createElement('div');
    col.className = 'bp-col';
    const slot = document.createElement('div');
    slot.className = 'bp-billing';
    slot.id = 'bpBilling';
    slot.hidden = true;
    MAIN.parentNode.insertBefore(col, MAIN);
    col.appendChild(slot);
    col.appendChild(MAIN);
    return slot;
  })();

  /* ---------- textos del portal ---------- */
  B.extend({
    p_section:     { es: 'Sección', en: 'Section', fr: 'Rubrique', it: 'Sezione' },
    p_nav_label:   { es: 'Mi cuenta', en: 'My account', fr: 'Mon compte', it: 'Il mio account' },
    p_home:        { es: 'Resumen', en: 'Overview', fr: 'Résumé', it: 'Riepilogo' },
    p_orders:      { es: 'Pedidos', en: 'Orders', fr: 'Commandes', it: 'Ordini' },
    p_docs:        { es: 'Documentos', en: 'Documents', fr: 'Documents', it: 'Documenti' },
    p_prices:      { es: 'Precios', en: 'Price list', fr: 'Prix', it: 'Listino prezzi' },
    p_details:     { es: 'Datos', en: 'Details', fr: 'Coordonnées', it: 'Dati' },
    p_admin:       { es: 'Bandeja SES', en: 'SES inbox', fr: 'Boîte SES', it: 'Posta SES' },
    p_company:     { es: 'Empresa', en: 'Company', fr: 'Société', it: 'Azienda' },
    p_updated:     { es: 'Actualizado el {date}', en: 'Updated on {date}', fr: 'Mis à jour le {date}', it: 'Aggiornato il {date}' },
    p_hello:       { es: 'Tu cuenta', en: 'Your account', fr: 'Votre compte', it: 'Il tuo account' },
    p_current:     { es: 'Pedidos en curso', en: 'Orders in progress', fr: 'Commandes en cours', it: 'Ordini in corso' },
    p_no_current:  { es: 'No tienes pedidos en curso.', en: 'You have no orders in progress.', fr: 'Vous n\'avez aucune commande en cours.', it: 'Non hai ordini in corso.' },
    p_new_order:   { es: 'Hacer pedido {season}', en: 'Place {season} order', fr: 'Commander {season}', it: 'Ordina {season}' },
    p_last_docs:   { es: 'Últimos documentos', en: 'Latest documents', fr: 'Derniers documents', it: 'Ultimi documenti' },
    p_no_docs:     { es: 'Todavía no hay documentos en tu cuenta.', en: 'There are no documents in your account yet.', fr: 'Aucun document dans votre compte pour l\'instant.', it: 'Non ci sono ancora documenti nel tuo account.' },
    p_all_docs:    { es: 'Ver todos los documentos', en: 'See all documents', fr: 'Voir tous les documents', it: 'Vedi tutti i documenti' },
    p_quick:       { es: 'Accesos rápidos', en: 'Shortcuts', fr: 'Raccourcis', it: 'Scorciatoie' },
    p_collection:  { es: 'Colección', en: 'Collection', fr: 'Collection', it: 'Collezione' },
    p_coll_title:  { es: 'Colección {season}', en: '{season} collection', fr: 'Collection {season}', it: 'Collezione {season}' },
    p_coll_text:   { es: 'Mira la colección con tus precios, descarga el linesheet y haz tu pedido.', en: 'Browse the collection with your prices, download the linesheet and place your order.', fr: 'Découvrez la collection avec vos prix, téléchargez le linesheet et passez commande.', it: 'Sfoglia la collezione con i tuoi prezzi, scarica il linesheet e fai il tuo ordine.' },
    p_coll_go:     { es: 'Ver la colección y pedir', en: 'View the collection and order', fr: 'Voir la collection et commander', it: 'Vedi la collezione e ordina' },
    p_lookbook:    { es: 'Ver lookbook', en: 'View lookbook', fr: 'Voir le lookbook', it: 'Vedi lookbook' },
    p_see_prices:  { es: 'Ver precios', en: 'See price list', fr: 'Voir les prix', it: 'Vedi listino prezzi' },
    p_see_orders:  { es: 'Ver mis pedidos', en: 'See my orders', fr: 'Voir mes commandes', it: 'Vedi i miei ordini' },
    p_turn_me:     { es: 'Te toca a ti', en: 'Your turn', fr: 'À vous', it: 'Tocca a te' },
    p_turn_ses:    { es: 'Pendiente de SES', en: 'Waiting for SES', fr: 'En attente de SES', it: 'In attesa di SES' },
    p_turn_buyer:  { es: 'Pendiente del cliente', en: 'Waiting for customer', fr: 'En attente du client', it: 'In attesa del cliente' },
    p_units:       { es: '{n} uds', en: '{n} units', fr: '{n} unités', it: '{n} pz' },
    p_lines:       { es: '{n} líneas', en: '{n} lines', fr: '{n} lignes', it: '{n} righe' },
    p_season:      { es: 'Temporada', en: 'Season', fr: 'Saison', it: 'Stagione' },
    p_portal_reqs: { es: 'Pedidos hechos en la web', en: 'Orders placed online', fr: 'Commandes passées en ligne', it: 'Ordini fatti online' },
    p_history:     { es: 'Historial', en: 'History', fr: 'Historique', it: 'Storico' },
    p_no_reqs:     { es: 'No hay pedidos web en esta temporada.', en: 'No online orders this season.', fr: 'Aucune commande en ligne cette saison.', it: 'Nessun ordine online in questa stagione.' },
    p_no_history:  { es: 'No hay pedidos anteriores en esta temporada.', en: 'No previous orders this season.', fr: 'Aucune commande précédente cette saison.', it: 'Nessun ordine precedente in questa stagione.' },
    p_repeat:      { es: 'Repetir pedido', en: 'Repeat order', fr: 'Recommander', it: 'Ripeti ordine' },
    p_show_lines:  { es: 'Ver líneas', en: 'Show lines', fr: 'Voir les lignes', it: 'Vedi righe' },
    p_hide_lines:  { es: 'Ocultar líneas', en: 'Hide lines', fr: 'Masquer les lignes', it: 'Nascondi righe' },
    p_shipped:     { es: 'enviadas', en: 'shipped', fr: 'expédiées', it: 'spedite' },
    p_open:        { es: 'Abrir', en: 'Open', fr: 'Ouvrir', it: 'Apri' },
    p_back_orders: { es: 'Volver a pedidos', en: 'Back to orders', fr: 'Retour aux commandes', it: 'Torna agli ordini' },
    p_back_inbox:  { es: 'Volver a la bandeja', en: 'Back to inbox', fr: 'Retour à la boîte', it: 'Torna alla posta' },
    // estados del pedido web
    st_DRAFT:            { es: 'Borrador', en: 'Draft', fr: 'Brouillon', it: 'Bozza' },
    st_SUBMITTED:        { es: 'Enviado, pendiente de revisión', en: 'Sent, awaiting review', fr: 'Envoyée, en attente de validation', it: 'Inviato, in attesa di revisione' },
    st_CHANGES_PROPOSED: { es: 'SES propone cambios', en: 'SES proposes changes', fr: 'SES propose des modifications', it: 'SES propone modifiche' },
    st_COUNTER:          { es: 'Has respondido, pendiente de SES', en: 'You replied, waiting for SES', fr: 'Vous avez répondu, en attente de SES', it: 'Hai risposto, in attesa di SES' },
    st_COUNTER_admin:    { es: 'El cliente ha respondido', en: 'Customer replied', fr: 'Le client a répondu', it: 'Il cliente ha risposto' },
    st_APPROVED:         { es: 'Aprobado', en: 'Approved', fr: 'Validée', it: 'Approvato' },
    st_CANCELLED:        { es: 'Cancelado', en: 'Cancelled', fr: 'Annulée', it: 'Annullato' },
    st_cancelled_by_buyer: { es: 'Cancelado por ti', en: 'Cancelled by you', fr: 'Annulée par vous', it: 'Annullato da te' },
    st_cancelled_by_ses:   { es: 'Cancelado por SES', en: 'Cancelled by SES', fr: 'Annulée par SES', it: 'Annullato da SES' },
    // estados del historial (CRM)
    os_PREPARING: { es: 'En preparación', en: 'Being prepared', fr: 'En préparation', it: 'In preparazione' },
    os_SHIPPED:   { es: 'Enviado', en: 'Shipped', fr: 'Expédiée', it: 'Spedito' },
    os_INVOICED:  { es: 'Facturado', en: 'Invoiced', fr: 'Facturée', it: 'Fatturato' },
    os_CLOSED:    { es: 'Cerrado', en: 'Closed', fr: 'Clôturée', it: 'Chiuso' },
    os_CANCELLED: { es: 'Cancelado', en: 'Cancelled', fr: 'Annulée', it: 'Annullato' },
    // detalle y negociación
    d_versions:    { es: 'Versiones', en: 'Versions', fr: 'Versions', it: 'Versioni' },
    d_version:     { es: 'Versión {n}', en: 'Version {n}', fr: 'Version {n}', it: 'Versione {n}' },
    d_by_you:      { es: 'Tú', en: 'You', fr: 'Vous', it: 'Tu' },
    d_by_ses:      { es: 'SES', en: 'SES', fr: 'SES', it: 'SES' },
    d_by_customer: { es: 'Cliente', en: 'Customer', fr: 'Client', it: 'Cliente' },
    d_changes:     { es: 'Cambios respecto a la versión {n}', en: 'Changes from version {n}', fr: 'Modifications par rapport à la version {n}', it: 'Modifiche rispetto alla versione {n}' },
    d_no_changes:  { es: 'Sin cambios en las cantidades.', en: 'No quantity changes.', fr: 'Aucun changement de quantité.', it: 'Nessuna modifica alle quantità.' },
    d_lines_now:   { es: 'Líneas de la versión {n}', en: 'Lines in version {n}', fr: 'Lignes de la version {n}', it: 'Righe della versione {n}' },
    d_item:        { es: 'Artículo', en: 'Item', fr: 'Article', it: 'Articolo' },
    d_qty:         { es: 'Uds', en: 'Units', fr: 'Unités', it: 'Pz' },
    d_price:       { es: 'Precio', en: 'Price', fr: 'Prix', it: 'Prezzo' },
    d_amount:      { es: 'Importe', en: 'Amount', fr: 'Montant', it: 'Importo' },
    d_total:       { es: 'Total', en: 'Total', fr: 'Total', it: 'Totale' },
    d_before:      { es: 'Antes', en: 'Before', fr: 'Avant', it: 'Prima' },
    d_now:         { es: 'Ahora', en: 'Now', fr: 'Maintenant', it: 'Ora' },
    d_change:      { es: 'Cambio', en: 'Change', fr: 'Changement', it: 'Modifica' },
    d_up:          { es: 'Sube', en: 'Up', fr: 'Hausse', it: 'Aumenta' },
    d_down:        { es: 'Baja', en: 'Down', fr: 'Baisse', it: 'Diminuisce' },
    d_removed:     { es: 'Quitado', en: 'Removed', fr: 'Retiré', it: 'Rimosso' },
    d_new:         { es: 'Nuevo', en: 'New', fr: 'Nouveau', it: 'Nuovo' },
    d_comment:     { es: 'Comentario', en: 'Comment', fr: 'Commentaire', it: 'Commento' },
    d_delivery:    { es: 'Entrega en', en: 'Deliver to', fr: 'Livraison à', it: 'Consegna a' },
    d_po:          { es: 'Tu referencia', en: 'Your reference', fr: 'Votre référence', it: 'Il tuo riferimento' },
    d_accept:      { es: 'Aceptar cambios', en: 'Accept changes', fr: 'Accepter les modifications', it: 'Accetta le modifiche' },
    d_counter:     { es: 'Responder con cambios', en: 'Reply with changes', fr: 'Répondre avec des modifications', it: 'Rispondi con modifiche' },
    d_cancel:      { es: 'Cancelar pedido', en: 'Cancel order', fr: 'Annuler la commande', it: 'Annulla ordine' },
    d_approve:     { es: 'Aprobar pedido', en: 'Approve order', fr: 'Valider la commande', it: 'Approva ordine' },
    d_propose:     { es: 'Proponer cambios', en: 'Propose changes', fr: 'Proposer des modifications', it: 'Proponi modifiche' },
    d_send_counter:{ es: 'Enviar mi respuesta', en: 'Send my reply', fr: 'Envoyer ma réponse', it: 'Invia la mia risposta' },
    d_send_propose:{ es: 'Enviar propuesta al cliente', en: 'Send proposal to customer', fr: 'Envoyer la proposition', it: 'Invia proposta al cliente' },
    d_discard:     { es: 'Descartar cambios', en: 'Discard changes', fr: 'Annuler les modifications', it: 'Scarta modifiche' },
    d_edit_help:   { es: 'Cambia las cantidades (0 quita la línea) y deja un comentario si hace falta.', en: 'Change the quantities (0 removes the line) and leave a comment if needed.', fr: 'Modifiez les quantités (0 retire la ligne) et laissez un commentaire si besoin.', it: 'Modifica le quantità (0 rimuove la riga) e lascia un commento se serve.' },
    d_comment_ph:  { es: 'Explica el cambio (opcional)', en: 'Explain the change (optional)', fr: 'Expliquez la modification (facultatif)', it: 'Spiega la modifica (facoltativo)' },
    d_line_comment:{ es: 'Nota para esta línea', en: 'Note for this line', fr: 'Note pour cette ligne', it: 'Nota per questa riga' },
    d_continue:    { es: 'Seguir con el pedido', en: 'Continue the order', fr: 'Continuer la commande', it: 'Continua l\'ordine' },
    d_accept_q:    { es: '¿Aceptar la propuesta de SES?', en: 'Accept the SES proposal?', fr: 'Accepter la proposition de SES ?', it: 'Accettare la proposta di SES?' },
    d_accept_t:    { es: 'El pedido quedará aprobado con la versión {n}: {units} y {total}.', en: 'The order will be approved with version {n}: {units} and {total}.', fr: 'La commande sera validée avec la version {n} : {units} et {total}.', it: 'L\'ordine sarà approvato con la versione {n}: {units} e {total}.' },
    d_approve_q:   { es: '¿Aprobar este pedido?', en: 'Approve this order?', fr: 'Valider cette commande ?', it: 'Approvare questo ordine?' },
    d_approve_t:   { es: 'Se aprueba la versión {n} tal cual: {units} y {total}. Pasará al CRM.', en: 'Version {n} is approved as is: {units} and {total}. It will go to the CRM.', fr: 'La version {n} est validée telle quelle : {units} et {total}.', it: 'La versione {n} viene approvata così: {units} e {total}.' },
    d_cancel_q:    { es: '¿Cancelar este pedido?', en: 'Cancel this order?', fr: 'Annuler cette commande ?', it: 'Annullare questo ordine?' },
    d_cancel_t:    { es: 'No se puede deshacer. Si quieres cambiar cantidades, usa «Responder con cambios».', en: 'This cannot be undone. To change quantities, use "Reply with changes".', fr: 'Action irréversible. Pour modifier les quantités, utilisez « Répondre avec des modifications ».', it: 'Non si può annullare. Per cambiare quantità usa "Rispondi con modifiche".' },
    d_cancel_reason: { es: 'Motivo (opcional)', en: 'Reason (optional)', fr: 'Motif (facultatif)', it: 'Motivo (facoltativo)' },
    d_keep:        { es: 'No, mantener', en: 'No, keep it', fr: 'Non, garder', it: 'No, mantieni' },
    d_done_accept: { es: 'Pedido aprobado.', en: 'Order approved.', fr: 'Commande validée.', it: 'Ordine approvato.' },
    d_done_counter:{ es: 'Respuesta enviada a SES.', en: 'Reply sent to SES.', fr: 'Réponse envoyée à SES.', it: 'Risposta inviata a SES.' },
    d_done_propose:{ es: 'Propuesta enviada al cliente.', en: 'Proposal sent to the customer.', fr: 'Proposition envoyée au client.', it: 'Proposta inviata al cliente.' },
    d_done_cancel: { es: 'Pedido cancelado.', en: 'Order cancelled.', fr: 'Commande annulée.', it: 'Ordine annullato.' },
    d_same:        { es: 'No has cambiado nada todavía.', en: 'You have not changed anything yet.', fr: 'Vous n\'avez rien modifié.', it: 'Non hai ancora cambiato nulla.' },
    d_empty_lines: { es: 'El pedido no puede quedarse sin unidades. Para anularlo, usa «Cancelar pedido».', en: 'The order cannot be left without units. To void it, use "Cancel order".', fr: 'La commande ne peut pas rester vide. Pour l\'annuler, utilisez « Annuler la commande ».', it: 'L\'ordine non può restare senza unità. Per annullarlo usa "Annulla ordine".' },
    d_reloaded:    { es: 'Hemos cargado la versión más reciente.', en: 'We loaded the latest version.', fr: 'Nous avons chargé la dernière version.', it: 'Abbiamo caricato l\'ultima versione.' },
    d_show_all:    { es: 'Ver también las líneas sin cambios', en: 'Also show unchanged lines', fr: 'Afficher aussi les lignes inchangées', it: 'Mostra anche le righe invariate' },
    d_less:        { es: 'Menos', en: 'Less', fr: 'Moins', it: 'Meno' },
    d_more:        { es: 'Más', en: 'More', fr: 'Plus', it: 'Più' },
    // documentos
    doc_all:       { es: 'Todos', en: 'All', fr: 'Tous', it: 'Tutti' },
    doc_INVOICE:   { es: 'Factura', en: 'Invoice', fr: 'Facture', it: 'Fattura' },
    doc_CREDIT_NOTE: { es: 'Abono', en: 'Credit note', fr: 'Avoir', it: 'Nota di credito' },
    doc_DELIVERY_NOTE: { es: 'Albarán', en: 'Delivery note', fr: 'Bon de livraison', it: 'Documento di trasporto' },
    doc_PROFORMA:  { es: 'Proforma', en: 'Proforma', fr: 'Proforma', it: 'Proforma' },
    doc_f_INVOICE: { es: 'Facturas', en: 'Invoices', fr: 'Factures', it: 'Fatture' },
    doc_f_CREDIT_NOTE: { es: 'Abonos', en: 'Credit notes', fr: 'Avoirs', it: 'Note di credito' },
    doc_f_DELIVERY_NOTE: { es: 'Albaranes', en: 'Delivery notes', fr: 'Bons de livraison', it: 'DDT' },
    doc_f_PROFORMA: { es: 'Proformas', en: 'Proformas', fr: 'Proformas', it: 'Proforma' },
    doc_all_seasons: { es: 'Todas las temporadas', en: 'All seasons', fr: 'Toutes les saisons', it: 'Tutte le stagioni' },
    doc_search:    { es: 'Buscar número', en: 'Search number', fr: 'Rechercher un numéro', it: 'Cerca numero' },
    doc_search_ph: { es: 'F-2610…', en: 'F-2610…', fr: 'F-2610…', it: 'F-2610…' },
    doc_download:  { es: 'Descargar PDF', en: 'Download PDF', fr: 'Télécharger le PDF', it: 'Scarica PDF' },
    doc_downloading: { es: 'Preparando…', en: 'Preparing…', fr: 'Préparation…', it: 'Preparazione…' },
    doc_none_filter: { es: 'No hay documentos con estos filtros.', en: 'No documents match these filters.', fr: 'Aucun document ne correspond à ces filtres.', it: 'Nessun documento con questi filtri.' },
    doc_clear:     { es: 'Quitar filtros', en: 'Clear filters', fr: 'Effacer les filtres', it: 'Rimuovi filtri' },
    doc_no_access: { es: 'Tu usuario no tiene acceso a los documentos de esta empresa. Pídeselo a SES si lo necesitas.', en: 'Your user has no access to this company\'s documents. Ask SES if you need it.', fr: 'Votre utilisateur n\'a pas accès aux documents de cette société. Demandez-le à SES.', it: 'Il tuo utente non ha accesso ai documenti di questa azienda. Chiedilo a SES.' },
    doc_of:        { es: 'De {n}', en: 'For {n}', fr: 'De {n}', it: 'Di {n}' },
    ds_PENDING:    { es: 'Pendiente de pago', en: 'Payment pending', fr: 'Paiement en attente', it: 'Pagamento in sospeso' },
    ds_PAID:       { es: 'Pagada', en: 'Paid', fr: 'Payée', it: 'Pagata' },
    ds_APPLIED:    { es: 'Aplicado', en: 'Applied', fr: 'Appliqué', it: 'Applicato' },
    doc_fail:      { es: 'No se pudo descargar el documento.', en: 'The document could not be downloaded.', fr: 'Le document n\'a pas pu être téléchargé.', it: 'Non è stato possibile scaricare il documento.' },
    // tarifa
    pr_title:      { es: 'Lista de precios {season}', en: '{season} price list', fr: 'Liste de prix {season}', it: 'Listino prezzi {season}' },
    pr_note:       { es: 'Precios mayoristas por unidad, IVA no incluido. Al lado tienes el PVP recomendado en el país de tu tienda.', en: 'Wholesale prices per unit, excl. VAT, shown next to the recommended retail price for your store\'s country.', fr: 'Prix de gros par unité, HT, à côté du prix de vente conseillé dans le pays de votre boutique.', it: 'Prezzi all\'ingrosso per unità, IVA esclusa, accanto al prezzo di vendita consigliato nel paese del tuo negozio.' },
    pr_style:      { es: 'Estilo', en: 'Style', fr: 'Style', it: 'Stile' },
    pr_wholesale:  { es: 'Mayorista', en: 'Wholesale', fr: 'Revendeur', it: 'Ingrosso' },
    pr_firm:       { es: 'Compra en firme', en: 'Wholesale order', fr: 'Achat ferme', it: 'Acquisto a fermo' },
    pr_deposit:    { es: 'Depósito', en: 'Consignment', fr: 'Dépôt-vente', it: 'Conto vendita' },
    pr_firm_or_deposit: { es: 'Compra en firme o depósito', en: 'Wholesale or consignment', fr: 'Achat ferme ou dépôt-vente', it: 'Acquisto a fermo o conto vendita' },
    pr_models_note: { es: 'Compra en firme: la mercancía es tuya desde la entrega. Depósito: solo pagas lo que vendes.', en: 'Wholesale order: the stock is yours from delivery. Consignment: you only pay for what you sell.', fr: 'Achat ferme : la marchandise vous appartient dès la livraison. Dépôt-vente : vous ne payez que ce que vous vendez.', it: 'Acquisto a fermo: la merce è tua dalla consegna. Conto vendita: paghi solo ciò che vendi.' },
    pr_rrp:        { es: 'PVP {country}', en: 'RRP {country}', fr: 'PVC {country}', it: 'PVP {country}' },
    rrp_not_configured: { es: 'Sin PVP configurado', en: 'No recommended retail price configured', fr: 'Prix conseillé non configuré', it: 'Prezzo consigliato non configurato' },
    pr_none:       { es: 'Todavía no hay precios {season} para tu empresa. Te avisaremos cuando estén listos.', en: 'There are no {season} prices for your company yet. We will let you know when they are ready.', fr: 'Pas encore de tarifs {season} pour votre société. Nous vous préviendrons.', it: 'Non ci sono ancora prezzi {season} per la tua azienda. Ti avviseremo.' },
    pr_search:     { es: 'Buscar estilo', en: 'Search style', fr: 'Rechercher un style', it: 'Cerca stile' },
    pr_colors_one: { es: '1 color', en: '1 colour', fr: '1 couleur', it: '1 colore' },
    pr_colors:     { es: '{n} colores', en: '{n} colours', fr: '{n} couleurs', it: '{n} colori' },
    pr_range:      { es: '{min} a {max}', en: '{min} to {max}', fr: '{min} à {max}', it: '{min} a {max}' },
    pr_varies:     { es: 'según talla', en: 'by size', fr: 'selon la taille', it: 'secondo taglia' },
    // datos
    da_legal:      { es: 'Razón social', en: 'Legal name', fr: 'Raison sociale', it: 'Ragione sociale' },
    da_tax:        { es: 'NIF / VAT', en: 'Tax ID / VAT', fr: 'N° TVA', it: 'P. IVA' },
    da_stores:     { es: 'Tiendas', en: 'Stores', fr: 'Boutiques', it: 'Negozi' },
    da_country:    { es: 'País', en: 'Country', fr: 'Pays', it: 'Paese' },
    da_no_country: { es: 'País sin indicar (sin PVP)', en: 'Country not set (no RRP)', fr: 'Pays non renseigné (sans PVC)', it: 'Paese non indicato (senza PVP)' },
    da_access:     { es: 'Tu acceso', en: 'Your access', fr: 'Votre accès', it: 'Il tuo accesso' },
    da_user:       { es: 'Usuario', en: 'User', fr: 'Utilisateur', it: 'Utente' },
    da_can_order:  { es: 'Puede hacer pedidos', en: 'Can place orders', fr: 'Peut commander', it: 'Può ordinare' },
    da_can_docs:   { es: 'Puede ver documentos', en: 'Can see documents', fr: 'Peut voir les documents', it: 'Può vedere i documenti' },
    da_yes:        { es: 'Sí', en: 'Yes', fr: 'Oui', it: 'Sì' },
    da_no:         { es: 'No', en: 'No', fr: 'Non', it: 'No' },
    da_change:     { es: 'Solicitar un cambio de datos', en: 'Request a change', fr: 'Demander une modification', it: 'Richiedi una modifica' },
    da_readonly:   { es: 'Estos datos vienen de nuestra ficha de cliente. Si algo no está bien, escríbenos y lo corregimos.', en: 'These details come from our customer records. If something is wrong, write to us and we will fix it.', fr: 'Ces données proviennent de notre fiche client. Si quelque chose est incorrect, écrivez-nous.', it: 'Questi dati provengono dalla nostra scheda cliente. Se qualcosa non va, scrivici.' },
    // admin
    ad_title:      { es: 'Bandeja de pedidos', en: 'Order inbox', fr: 'Boîte des commandes', it: 'Posta ordini' },
    ad_ses:        { es: 'Te toca (SES)', en: 'Your turn (SES)', fr: 'À vous (SES)', it: 'Tocca a te (SES)' },
    ad_buyer:      { es: 'Esperando al cliente', en: 'Waiting for customer', fr: 'En attente du client', it: 'In attesa del cliente' },
    ad_done:       { es: 'Aprobados y cancelados recientes', en: 'Recently approved and cancelled', fr: 'Validées et annulées récemment', it: 'Approvati e annullati di recente' },
    ad_empty:      { es: 'Nada pendiente.', en: 'Nothing pending.', fr: 'Rien en attente.', it: 'Niente in sospeso.' },
    // repetir pedido
    rp_title:      { es: 'Ya tienes un pedido en curso', en: 'You already have an order in progress', fr: 'Vous avez déjà une commande en cours', it: 'Hai già un ordine in corso' },
    rp_text:       { es: 'En la página de pedidos hay {units} sin enviar. ¿Qué hacemos con ellas?', en: 'The order page has {units} not yet sent. What should we do with them?', fr: 'La page de commande contient {units} non envoyées. Que faisons-nous ?', it: 'Nella pagina ordini ci sono {units} non inviate. Cosa facciamo?' },
    rp_replace:    { es: 'Sustituir', en: 'Replace', fr: 'Remplacer', it: 'Sostituisci' },
    rp_add:        { es: 'Añadir', en: 'Add', fr: 'Ajouter', it: 'Aggiungi' },
    rp_loaded:     { es: 'Pedido {season} cargado: {ok} de {all} uds disponibles en {now}.', en: '{season} order loaded: {ok} of {all} units available in {now}.', fr: 'Commande {season} chargée : {ok} sur {all} unités disponibles en {now}.', it: 'Ordine {season} caricato: {ok} di {all} pz disponibili in {now}.' },
    rp_unavail:    { es: 'No disponibles en {now}:', en: 'Not available in {now}:', fr: 'Indisponibles en {now} :', it: 'Non disponibili in {now}:' },
    rp_nothing:    { es: 'Ninguno de los artículos de este pedido está disponible en {now}.', en: 'None of the items in this order are available in {now}.', fr: 'Aucun article de cette commande n\'est disponible en {now}.', it: 'Nessun articolo di questo ordine è disponibile in {now}.' },
    // estados generales
    g_error:       { es: 'No hemos podido cargar esta sección.', en: 'We could not load this section.', fr: 'Impossible de charger cette section.', it: 'Non è stato possibile caricare questa sezione.' },
    g_no_company:  { es: 'Tu cuenta no tiene acceso todavía. Si crees que es un error, escríbenos a antonio@sespalma.com.', en: 'Your account does not have access yet. If you think this is a mistake, write to antonio@sespalma.com.', fr: 'Votre compte n\'a pas encore d\'accès. S\'il s\'agit d\'une erreur, écrivez à antonio@sespalma.com.', it: 'Il tuo account non ha ancora accesso. Se pensi sia un errore, scrivi a antonio@sespalma.com.' },
    g_choose_company: { es: 'Elige empresa', en: 'Choose company', fr: 'Choisir la société', it: 'Scegli azienda' },
    g_not_found:   { es: 'Esta página no existe.', en: 'This page does not exist.', fr: 'Cette page n\'existe pas.', it: 'Questa pagina non esiste.' },
    g_go_home:     { es: 'Ir al resumen', en: 'Go to overview', fr: 'Aller au résumé', it: 'Vai al riepilogo' },
    g_loading:     { es: 'Cargando', en: 'Loading', fr: 'Chargement', it: 'Caricamento' },
    pr_no_match:   { es: 'Ningún estilo coincide con la búsqueda.', en: 'No style matches your search.', fr: 'Aucun style ne correspond à la recherche.', it: 'Nessuno stile corrisponde alla ricerca.' },
    g_slow:        { es: 'Está tardando más de lo normal…', en: 'This is taking longer than usual…', fr: 'Cela prend plus de temps que d\'habitude…', it: 'Ci sta mettendo più del solito…' },
    g_login_title: { es: 'Acceso mayoristas', en: 'Wholesale access', fr: 'Accès revendeurs', it: 'Accesso rivenditori' },
    g_vat_excl:    { es: 'sin IVA', en: 'excl. VAT', fr: 'HT', it: 'IVA escl.' },
    g_vat_incl:    { es: 'IVA incl.', en: 'incl. VAT', fr: 'TTC', it: 'IVA incl.' },
    // grupos (administrador de varios hoteles)
    p_group:       { es: 'Grupo', en: 'Group', fr: 'Groupe', it: 'Gruppo' },
    g_all_stores:  { es: 'Todos los hoteles · {group}', en: 'All hotels · {group}', fr: 'Tous les hôtels · {group}', it: 'Tutti gli hotel · {group}' },
    g_hotels:      { es: 'Hoteles', en: 'Hotels', fr: 'Hôtels', it: 'Hotel' },
    col_store:     { es: 'Hotel', en: 'Hotel', fr: 'Hôtel', it: 'Hotel' },
    pr_choose_store: { es: 'Los precios pueden ser distintos en cada hotel. Elige uno para ver sus precios.', en: 'Prices may differ between hotels. Choose one to see its price list.', fr: 'Les prix peuvent varier selon l\'hôtel. Choisissez-en un pour voir ses prix.', it: 'I prezzi possono variare tra gli hotel. Scegline uno per vedere il listino.' },
    pr_same_all:   { es: 'Mismo precio en todos los hoteles.', en: 'Same price in every hotel.', fr: 'Même prix dans tous les hôtels.', it: 'Stesso prezzo in tutti gli hotel.' },
    g_pick_hotel:  { es: '¿Para qué hotel es el pedido?', en: 'Which hotel is this order for?', fr: 'Pour quel hôtel est cette commande ?', it: 'Per quale hotel è l\'ordine?' },
    g_pick_hotel_t: { es: 'Cada pedido es de un hotel: se factura a su empresa y se entrega allí.', en: 'Each order belongs to one hotel: it is invoiced to its company and delivered there.', fr: 'Chaque commande concerne un hôtel : elle est facturée à sa société et livrée sur place.', it: 'Ogni ordine è di un hotel: viene fatturato alla sua società e consegnato lì.' },
    da_group_access: { es: 'Ves todos los hoteles del grupo.', en: 'You can see every hotel in the group.', fr: 'Vous voyez tous les hôtels du groupe.', it: 'Vedi tutti gli hotel del gruppo.' },
    da_sub:        { es: 'Tus datos de empresa. Los de facturación puedes completarlos o corregirlos aquí: los revisamos antes de aplicarlos.', en: 'Your company details. You can complete or correct your billing details here: we review them before applying them.', fr: 'Les données de votre société. Vous pouvez compléter ou corriger ici vos données de facturation : nous les vérifions avant de les appliquer.', it: 'I dati della tua azienda. Puoi completare o correggere qui i dati di fatturazione: li controlliamo prima di applicarli.' },
    da_billing:    { es: 'Datos de facturación', en: 'Billing details', fr: 'Données de facturation', it: 'Dati di fatturazione' },
    da_current:    { es: 'Lo que tenemos ahora', en: 'What we have now', fr: 'Ce que nous avons actuellement', it: 'Quello che abbiamo ora' },
    da_none:       { es: 'Aún no tenemos tus datos de facturación.', en: 'We do not have your billing details yet.', fr: 'Nous n\'avons pas encore vos données de facturation.', it: 'Non abbiamo ancora i tuoi dati di fatturazione.' },
    da_missing:    { es: 'Faltan: {list}.', en: 'Missing: {list}.', fr: 'Manquant : {list}.', it: 'Mancano: {list}.' },
    da_received:   { es: 'Recibido, lo revisamos.', en: 'Received, we will review it.', fr: 'Reçu, nous le vérifions.', it: 'Ricevuto, lo controlliamo.' },
    da_received_on:{ es: 'Enviado el {date}. Hasta que lo apliquemos seguirás viendo aquí los datos actuales.', en: 'Sent on {date}. Until we apply it you will keep seeing the current details here.', fr: 'Envoyé le {date}. Tant que nous ne l\'avons pas appliqué, vous verrez ici les données actuelles.', it: 'Inviato il {date}. Finché non lo applichiamo vedrai qui i dati attuali.' },
    da_applied_wait: { es: 'Ya los hemos aplicado. En unos minutos los verás aquí.', en: 'We have applied them. You will see them here in a few minutes.', fr: 'Nous les avons appliquées. Vous les verrez ici dans quelques minutes.', it: 'Li abbiamo applicati. Tra pochi minuti li vedrai qui.' },
    da_rejected:   { es: 'No hemos podido aplicar tu último envío. Revísalo y envíalo de nuevo.', en: 'We could not apply your last submission. Check it and send it again.', fr: 'Nous n\'avons pas pu appliquer votre dernier envoi. Vérifiez-le et renvoyez-le.', it: 'Non abbiamo potuto applicare il tuo ultimo invio. Controllalo e invialo di nuovo.' },
    da_ses_note:   { es: 'Nota de SES: {note}', en: 'Note from SES: {note}', fr: 'Note de SES : {note}', it: 'Nota di SES: {note}' },
    da_form:       { es: 'Completar o corregir', en: 'Complete or correct', fr: 'Compléter ou corriger', it: 'Completa o correggi' },
    da_edit:       { es: 'Corregir datos de facturación', en: 'Correct billing details', fr: 'Corriger les données de facturation', it: 'Correggi i dati di fatturazione' },
    da_street:     { es: 'Calle', en: 'Street', fr: 'Rue', it: 'Via' },
    da_number:     { es: 'Número', en: 'Number', fr: 'Numéro', it: 'Numero' },
    da_postcode:   { es: 'Código postal', en: 'Postcode', fr: 'Code postal', it: 'CAP' },
    da_city:       { es: 'Ciudad', en: 'City', fr: 'Ville', it: 'Città' },
    da_province:   { es: 'Provincia o región', en: 'Province or region', fr: 'Province ou région', it: 'Provincia o regione' },
    da_contact:    { es: 'Persona de contacto de facturación', en: 'Billing contact person', fr: 'Contact facturation', it: 'Referente per la fatturazione' },
    da_email:      { es: 'Email de facturación', en: 'Billing email', fr: 'E-mail de facturation', it: 'Email per la fatturazione' },
    da_address:    { es: 'Dirección', en: 'Address', fr: 'Adresse', it: 'Indirizzo' },
    da_pick_country: { es: 'Elige un país', en: 'Choose a country', fr: 'Choisissez un pays', it: 'Scegli un paese' },
    da_req_note:   { es: 'Los campos con * son obligatorios.', en: 'Fields marked * are required.', fr: 'Les champs marqués * sont obligatoires.', it: 'I campi con * sono obbligatori.' },
    da_tax_hint:   { es: 'Si es un VAT europeo, con el prefijo del país (p. ej. PT513293876).', en: 'For an EU VAT number, include the country prefix (e.g. PT513293876).', fr: 'Pour un n° de TVA européen, avec le préfixe du pays (ex. PT513293876).', it: 'Per una partita IVA europea, con il prefisso del paese (es. PT513293876).' },
    da_submit:     { es: 'Enviar para revisión', en: 'Send for review', fr: 'Envoyer pour vérification', it: 'Invia per revisione' },
    da_submit_again: { es: 'Enviar corrección', en: 'Send correction', fr: 'Envoyer la correction', it: 'Invia correzione' },
    da_cancel:     { es: 'Cancelar', en: 'Cancel', fr: 'Annuler', it: 'Annulla' },
    da_err_required: { es: 'Este dato es obligatorio.', en: 'This field is required.', fr: 'Ce champ est obligatoire.', it: 'Questo campo è obbligatorio.' },
    da_err_email:  { es: 'Revisa el email.', en: 'Check the email address.', fr: 'Vérifiez l\'adresse e-mail.', it: 'Controlla l\'indirizzo email.' },
    da_err_format: { es: 'Revisa el formato.', en: 'Check the format.', fr: 'Vérifiez le format.', it: 'Controlla il formato.' },
    da_err_length: { es: 'Revisa la longitud.', en: 'Check the length.', fr: 'Vérifiez la longueur.', it: 'Controlla la lunghezza.' },
    da_err_summary:{ es: 'Revisa los campos marcados.', en: 'Check the highlighted fields.', fr: 'Vérifiez les champs signalés.', it: 'Controlla i campi evidenziati.' },
    da_viewas:     { es: 'Vista de SES: solo lectura, no se puede enviar desde aquí.', en: 'SES view: read only, it cannot be sent from here.', fr: 'Vue SES : lecture seule, envoi impossible ici.', it: 'Vista SES: sola lettura, non si può inviare da qui.' },
    da_no_perm:    { es: 'Solo quien tiene permiso de pedido puede enviar cambios. Si algo no está bien, escríbenos.', en: 'Only users who can place orders can send changes. If something is wrong, write to us.', fr: 'Seuls les utilisateurs autorisés à commander peuvent envoyer des modifications. Écrivez-nous si besoin.', it: 'Solo chi può ordinare può inviare modifiche. Se qualcosa non va, scrivici.' },
    da_write:      { es: 'Escríbenos para otros cambios', en: 'Write to us for other changes', fr: 'Écrivez-nous pour d\'autres modifications', it: 'Scrivici per altre modifiche' },
  });

  /* ---------- catálogo (portal_catalog, solo con sesión): nombres, colores, tarifa y repetir pedido ---------- */
  let CATALOG = [];
  const SKU = new Map();     // sku -> meta
  const BY_KEY = new Map();  // ESTILO|color|talla -> sku
  function setCatalog(list) {
    CATALOG = Array.isArray(list) ? list : [];
    SKU.clear(); BY_KEY.clear();
    CATALOG.forEach((st, si) => st.colors.forEach((c) => c.sizes.forEach((sz) => {
      const meta = { sku: sz.sku, code: st.code, name: st.name, type: st.product_type, color: c.name, hex: c.hex, size: sz.size, order: si };
      SKU.set(sz.sku, meta);
      BY_KEY.set(`${st.code}|${norm(c.name)}|${norm(sz.size)}`, sz.sku);
    })));
  }
  // Fotos de estilos de temporadas pasadas (portal_catalog 'ARCHIVE': foto principal del producto en
  // la tienda, CDN de Shopify, por código de estilo). Solo para miniaturas de «Análisis»; si no carga, nada.
  let ARCHIVE_STYLES = {};
  async function ensureCatalog() {
    if (CATALOG.length) return;
    const [cur, arch] = await Promise.all([
      sb().from('portal_catalog').select('data').eq('season', SEASON).single(),
      sb().from('portal_catalog').select('data').eq('season', 'ARCHIVE').maybeSingle(),
    ]);
    if (cur.error) throw cur.error;
    setCatalog(cur.data && cur.data.data && cur.data.data.catalog);
    ARCHIVE_STYLES = (arch && !arch.error && arch.data && arch.data.data && arch.data.data.styles) || {};
  }
  // misma regla que la página de pedidos (resolveImg): nombre de fichero suelto = asset del tema
  function assetUrl(u) {
    if (!u) return null;
    const base = window.SES_ASSET_BASE;
    if (base && /^[\w.-]+\.(jpe?g|png|webp)$/i.test(u)) u = base + u;
    else if (base && u.indexOf('github.io/ses-pedidos/catalog/img/') > -1) u = base + u.substring(u.lastIndexOf('/') + 1);
    return B.safeUrl(u) || null;
  }
  // foto del estilo·color: la del color en el catálogo de la temporada, la del estilo, o la de la tienda
  // (estilos de temporadas pasadas); null si no hay ninguna (se pinta la muestra de color)
  function catalogThumb(code, color) {
    const st = CATALOG.find((x) => x.code === code);
    const c = st && (st.colors || []).find((x) => norm(x.name) === norm(color));
    return assetUrl(c && c.image) || assetUrl(st && st.image) || assetUrl(ARCHIVE_STYLES[code]) || null;
  }
  function norm(v) { return String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase(); }
  function lineLabel(l) {
    const m = SKU.get(l.sku);
    const name = (m && m.name) || l.style_name || l.style_code || l.sku;
    const color = (m && m.color) || l.color || '';
    const size = (m && m.size) || l.size || '';
    return { name, color, size, hex: m && m.hex };
  }

  /* ---------- estado ---------- */
  const S = {
    session: null, me: null, companyId: null, company: null,
    groupId: null, group: null, // vista «todos los hoteles» de un administrador de grupo
    route: null, renderSeq: 0,
    cache: {},
    editing: null, // { requestId, version, qty: {sku: n}, comments: {sku: txt}, comment }
  };
  const isAdmin = () => !!(S.me && S.me.is_admin);
  const sb = () => B.sb();
  const myCompanies = () => (S.me && S.me.companies) || [];
  const myGroups = () => (S.me && S.me.groups) || [];
  const companyById = (id) => myCompanies().find((c) => c.id === id) || null;
  const companyName = (id) => (companyById(id) || {}).name || '';
  // empresas visibles en la vista actual: la elegida o todas las del grupo (las que portal_me devuelve)
  function scopeCompanies() {
    if (S.group) return S.group.company_ids.map(companyById).filter(Boolean);
    return S.company ? [S.company] : [];
  }
  const scopeIds = () => scopeCompanies().map((c) => c.id);
  const canDocs = () => scopeCompanies().some((c) => c.can_see_documents);
  const canOrderAny = () => scopeCompanies().some((c) => c.can_order);
  const hasScope = () => !!(S.companyId || S.groupId);
  const sellStoresInScope = () => (S.sellStores || []).some((r) => scopeIds().includes(r.company_id));

  /* ---------- utilidades de pintado ---------- */
  function h1(text, sub) {
    return `<header class="bp-head"><h1 class="bp-title" tabindex="-1">${esc(text)}</h1>${sub ? `<p class="bp-sub">${sub}</p>` : ''}</header>`;
  }
  function skeleton(rows) {
    return `<div class="bp-skel" aria-hidden="true"><span class="bp-skel-line bp-skel-line--title"></span>${
      Array.from({ length: rows || 3 }, () => '<span class="bp-skel-card"></span>').join('')}</div>
      <p class="bp-sr" role="status">${esc(t('g_loading'))}…</p>`;
  }
  function errorBox(code, retry) {
    const id = 'r' + Math.random().toString(36).slice(2, 7);
    setTimeout(() => { const b = MAIN.querySelector('#' + id); if (b) b.addEventListener('click', retry); }, 0);
    return `<div class="bp-error" role="alert">${ICON.alert}<div><p>${esc(t('g_error'))} ${esc(B.errorMessage(code))}</p>
      <button type="button" class="b2b-btn b2b-btn--secondary" id="${id}">${esc(t('retry'))}</button></div></div>`;
  }
  function empty(text, action) {
    return `<div class="bp-empty"><p>${esc(text)}</p>${action || ''}</div>`;
  }
  function badge(text, kind, icon) {
    return `<span class="bp-badge bp-badge--${kind || 'neutral'}">${icon || ''}<span>${esc(text)}</span></span>`;
  }
  // Una sola etiqueta por estado: si te toca, «Te toca a ti: <estado>» (dorada, con reloj); si no, el estado.
  function stateChip(r, admin, cancelAction) {
    const open = r.turn && !['APPROVED', 'CANCELLED', 'DRAFT'].includes(r.status);
    const mine = open && (admin ? r.turn === 'SES' : r.turn === 'BUYER');
    const label = statusLabel(r, cancelAction, admin);
    if (mine) return badge(`${t('p_turn_me')}: ${label}`, 'turn', ICON.clock);
    return badge(label, open ? 'wait' : statusKind(r.status));
  }
  // el administrador ve la bandeja y los pedidos de todos: lo trata como «SES»
  function isAdminView() { return isAdmin() && (!S.companyId || (S.route && (S.route.name === 'admin' || S.route.admin))); }
  function statusLabel(r, cancelAction, admin) {
    if (r.status === 'CANCELLED' && cancelAction) return t('st_' + cancelAction);
    if (r.status === 'COUNTER' && (admin != null ? admin : isAdminView())) return t('st_COUNTER_admin');
    return t('st_' + r.status);
  }
  function statusKind(status) {
    return { APPROVED: 'ok', CANCELLED: 'muted', DRAFT: 'muted' }[status] || 'neutral';
  }
  const units = (n) => t('p_units', { n: B.fmtInt(n || 0) });
  const money = (n, cur) => B.fmtAmount(n, cur || 'EUR');

  async function guard(fn, retry) {
    try { return await fn(); }
    catch (e) {
      const code = B.errorCode(e);
      if (code === 'session_expired') { await B.signOut(); return null; }
      MAIN.innerHTML = errorBox(code, retry);
      return null;
    }
  }
  async function q(build) {
    const { data, error } = await build();
    if (error) throw error;
    return data;
  }

  /* ---------- arranque y sesión ---------- */
  let bar = null;
  async function boot() {
    bar = B.mountBar(ROOT.querySelector('.b2b-bar'), {
      page: 'portal', orderUrl: ORDER_URL,
      onLogout: () => { location.hash = '#/'; },
    });
    const topbar = ROOT.querySelector('.b2b-bar');
    if (window.ResizeObserver && topbar) new ResizeObserver(measureNav).observe(topbar);
    measureNav();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureNav);
    // al cambiar de idioma se repinta, pero el foco se queda en el botón de idioma pulsado
    B.onLang(() => { S.langRedraw = true; render(); });
    B.onAuth((event) => {
      if (event === 'SIGNED_OUT') { S.session = null; S.me = null; S.companyId = null; S.company = null; S.groupId = null; S.group = null; S.cache = {}; S.editing = null; bar.setSession(null); render(); }
      else if (event === 'PASSWORD_RECOVERY') { location.hash = '#/reset'; }
    });
    window.addEventListener('hashchange', render);
    let navRaf = 0;
    window.addEventListener('resize', () => { cancelAnimationFrame(navRaf); navRaf = requestAnimationFrame(measureNav); }, { passive: true });
    // Enlace de invitación o de recuperación: primero supabase-js consume los tokens del hash
    // (getSession espera a que termine); después se limpia la URL y se muestra «crear contraseña».
    await loadSession();
    if (B.needsPassword) {
      const ar = B.authRedirect || {};
      S.passwordMode = ar.type === 'invite' ? 'invite' : 'recovery';
      if (ar.route && ar.route !== '/reset') S.afterPassword = ar.route;
      B.cleanAuthUrl('#/reset');
    }
    afterRender(render());
  }

  // Agradecimiento SS26 (ses-b2b-gracias.js): se comprueba ya pintado el portal, para no pelear por el foco.
  function afterRender(p) {
    Promise.resolve(p).finally(() => {
      const session = S.session;
      const canShow = () => !!(session && S.session === session && S.me && !S.passwordMode &&
        !['reset', 'login', 'pending'].includes(parseRoute().name) && !ROOT.classList.contains('is-gate'));
      if (window.SESGracias && canShow()) window.SESGracias.check({ session: S.session, me: S.me, company: S.company, root: ROOT, orderUrl: ORDER_URL, canShow });
    });
  }

  async function loadSession() {
    S.session = await B.getSession();
    bar.setSession(S.session);
    if (!S.session) return;
    try {
      S.me = await B.me(true);
    } catch (e) {
      S.meError = (e && e.code) || 'unknown';
      return;
    }
    S.meError = null;
    if ((S.me.companies || []).length || S.me.is_admin) {
      // sin catálogo el portal sigue funcionando (referencias del CRM), pero sin nombres ni repetir pedido
      try { await ensureCatalog(); } catch (e) { console.warn('catálogo no disponible', e); }
    }
    // tiendas en depósito o bill-and-hold (para «Reportar ventas»); sin ellas la sección no aparece
    S.sellStores = [];
    if (B.portalSellout) {
      try { S.sellStores = await B.portalSellout.stores(myCompanies().map((c) => c.id)); } catch (e) { S.sellStores = []; }
    }
    const gid = B.chosenGroupId(S.me);
    if (gid) setGroup(gid);
    else setCompany(B.chosenCompanyId(S.me));
  }

  function setCompany(id) {
    S.company = companyById(id);
    S.companyId = S.company ? S.company.id : null;
    S.groupId = null; S.group = null;
    B.chooseCompany(S.companyId);
    B.chooseGroup(null);
    S.cache = {};
    S.editing = null;
  }

  function setGroup(id) {
    S.group = myGroups().find((g) => g.id === id) || null;
    S.groupId = S.group ? S.group.id : null;
    S.company = null; S.companyId = null;
    B.chooseGroup(S.groupId);
    S.cache = {};
    S.editing = null;
  }
  // «g:<id>» = todos los hoteles del grupo; si no, una empresa
  function setScope(value) {
    if (value && value.indexOf('g:') === 0) setGroup(value.slice(2));
    else setCompany(value || null);
  }

  /* ---------- router ---------- */
  function parseRoute() {
    const h = (location.hash || '').replace(/^#/, '');
    // tokens del enlace todavía sin consumir por supabase-js: no es una ruta
    if (/(^|&)(access_token|refresh_token|error|error_code|error_description)=/.test(h)) return { name: 'pending' };
    const parts = h.split('/').filter(Boolean);
    const name = parts[0] || 'home';
    if (name === 'pedidos' && parts[1]) return { name: 'request', id: decodeURIComponent(parts[1]) };
    if (name === 'admin' && parts[1]) return { name: 'request', id: decodeURIComponent(parts[1]), admin: true };
    return { name: { pedidos: 'orders', analisis: 'analytics', ventas: 'sales', documentos: 'docs', tarifa: 'prices', datos: 'details', admin: 'admin', reset: 'reset', login: 'login' }[name] || (name === 'home' ? 'home' : 'notfound') };
  }

  // Una línea si a la empresa activa le faltan datos de facturación (no en «Datos», que ya es el formulario).
  function paintBilling() {
    const r = S.route || {};
    const show = S.session && S.companyId && !S.groupId && !['details', 'admin', 'notfound', 'reset', 'login', 'pending'].includes(r.name) && !(r.name === 'request' && r.admin);
    B.billing.mount(BILL_SLOT, show ? { companyId: S.companyId, href: '#/datos', focusAfter: MAIN } : null);
  }

  function render() {
    if (B.portalAnalytics && B.portalAnalytics.deactivate) B.portalAnalytics.deactivate();
    ROOT.classList.remove('is-gate');
    S.route = parseRoute();
    paintBilling();
    const seq = ++S.renderSeq;
    S.focusLock = S.langRedraw ? seq : null;
    S.langRedraw = false;
    const r = S.route;
    if (r.name === 'pending') { renderNav(false); MAIN.innerHTML = skeleton(1); return null; }
    if (r.name === 'reset') { renderNav(false); return viewReset(); }
    if (!S.session) { renderNav(false); return viewLogin(); }
    if (S.meError) {
      renderNav(false);
      MAIN.innerHTML = errorBox(S.meError, async () => { await loadSession(); render(); });
      return null;
    }
    const companies = (S.me && S.me.companies) || [];
    if (!companies.length && !isAdmin()) {
      renderNav(false);
      MAIN.innerHTML = h1(t('p_hello')) + empty(t('g_no_company'), `<div class="bp-quick"><a class="b2b-btn b2b-btn--secondary" href="${B.ACCESS_MAILTO}">antonio@sespalma.com</a>
        <button type="button" class="b2b-btn b2b-btn--ghost" id="bpNoAccessOut">${esc(t('acc_logout'))}</button></div>`);
      MAIN.querySelector('#bpNoAccessOut').addEventListener('click', () => B.signOut());
      return focusMain();
    }
    if (!hasScope() && (companies.length > 1 || myGroups().length) && !isAdmin()) {
      renderNav(false);
      return viewChooseCompany();
    }
    renderNav(true);
    S.editing = S.editing && r.name === 'request' && S.editing.requestId === r.id ? S.editing : null;
    const views = { home: viewHome, orders: viewOrders, analytics: viewAnalytics, sales: viewSales, request: viewRequest, docs: viewDocs, prices: viewPrices, details: viewDetails, admin: viewAdmin, login: viewHomeRedirect, notfound: viewNotFound };
    let fn = views[r.name] || viewNotFound;
    if (!hasScope() && isAdmin() && ['home', 'orders', 'analytics', 'sales', 'docs', 'prices', 'details'].includes(r.name)) fn = viewAdmin;
    if (r.name === 'admin' && !isAdmin()) fn = viewNotFound;
    MAIN.innerHTML = skeleton(r.name === 'home' ? 2 : 4);
    const slow = setTimeout(() => {
      if (seq === S.renderSeq && MAIN.querySelector('.bp-skel')) MAIN.insertAdjacentHTML('beforeend', `<p class="bp-slow">${esc(t('g_slow'))}</p>`);
    }, 8000);
    return Promise.resolve(fn(seq)).finally(() => clearTimeout(slow));
  }
  const stale = (seq) => seq !== S.renderSeq;
  function viewHomeRedirect() { location.hash = '#/'; }
  function focusMain() {
    if (S.focusLock && S.focusLock === S.renderSeq) return;
    const h = MAIN.querySelector('.bp-title');
    if (h) h.focus({ preventScroll: true });
    window.scrollTo(0, 0);
  }

  // «Ver como…» (core): el admin entra en el portal de una empresa en solo lectura; al cambiar se recarga la sesión.
  async function onViewAs(id) {
    await loadSession();
    const target = id ? '#/' : '#/admin';
    if (location.hash !== target) location.hash = target; else render();
  }

  function renderNav(show) {
    B.paintViewAs(show ? S.me : null, { root: ROOT, onChange: onViewAs });
    NAV.hidden = !show;
    if (!show) { NAV.innerHTML = ''; return; }
    NAV.setAttribute('aria-label', t('p_nav_label'));
    const r = S.route;
    const items = [];
    if (hasScope()) {
      items.push(['home', '#/', t('p_home')], ['collection', ORDER_URL, t('p_collection')], ['orders', '#/pedidos', t('p_orders')]);
      if (B.portalAnalytics) items.push(['analytics', '#/analisis', t('an_nav')]);
      if (B.portalSellout && sellStoresInScope()) items.push(['sales', '#/ventas', t('so_nav')]);
      if (canDocs()) items.push(['docs', '#/documentos', t('p_docs')]);
      items.push(['prices', '#/tarifa', t('p_prices')], ['details', '#/datos', t('p_details')]);
    }
    if (isAdmin()) items.push(['admin', '#/admin', t('p_admin')]);
    const active = r.name === 'request' ? (r.admin ? 'admin' : 'orders') : r.name;
    const companies = myCompanies();
    const switcher = isAdmin() ? `
      <div class="bp-company">
        ${S.company ? `<span class="b2b-label">${esc(t('p_company'))}</span><p class="bp-company-name">${esc(S.company.name)}</p>` : ''}
        <button type="button" class="b2b-btn b2b-btn--secondary bp-viewas-btn">${ICON.eye}<span>${esc(t('va_btn'))}</span></button>
      </div>` : companies.length > 1 || myGroups().length ? `
      <div class="bp-company">
        <label class="b2b-label" for="bpCompany">${esc(t(myGroups().length ? 'p_group' : 'p_company'))}</label>
        <select id="bpCompany" class="b2b-select">
          ${isAdmin() ? `<option value="">${esc(t('p_admin'))}</option>` : ''}
          ${scopeOptions()}
        </select>
      </div>` : (S.company ? `<p class="bp-company-name">${esc(S.company.name)}</p>` : '');
    NAV.innerHTML = `${switcher}
      <div class="bp-mobile-nav">
        <label for="bpSection">${esc(t('p_section'))}</label>
        <select id="bpSection" class="b2b-select">
          ${items.map(([k, href, label]) => `<option value="${href}"${k === active ? ' selected' : ''}>${esc(label)}</option>`).join('')}
        </select>
      </div>
      <ul class="bp-tabs" role="list">
        ${items.map(([k, href, label]) => `<li><a class="bp-tab${k === active ? ' is-active' : ''}" href="${esc(href)}"${k === active ? ' aria-current="page"' : ''}${k === 'collection' && S.groupId && canOrderAny() ? ' data-new-order' : ''}>${esc(label)}</a></li>`).join('')}
      </ul>
`;
    const section = NAV.querySelector('#bpSection');
    if (section) section.addEventListener('change', () => {
      if (section.value.charAt(0) === '#') { location.hash = section.value; return; }
      // «Colección» sale del portal: en la vista de grupo, primero el hotel
      const back = (section.querySelector(`option[value="${location.hash || '#/'}"]`) || {}).value;
      if (back) section.value = back;
      if (S.groupId && canOrderAny()) pickHotelAndOrder(); else location.assign(ORDER_URL);
    });
    wireNewOrder(NAV);
    const vab = NAV.querySelector('.bp-viewas-btn');
    if (vab) vab.addEventListener('click', async () => {
      const id = await B.pickViewAs({ root: ROOT });
      if (!id) return;
      B.setViewAs(id);
      onViewAs(id);
    });
    const sel = NAV.querySelector('#bpCompany');
    if (sel) sel.addEventListener('change', () => { setScope(sel.value || null); location.hash = sel.value ? '#/' : '#/admin'; render(); });
    measureNav();
  }
  // El selector queda debajo de la cabecera; la empresa sube con el contenido.
  // Medir evita desfases con zoom, traducciones, fuentes y cambios de tamaño.
  function measureNav() {
    const topbar = ROOT.querySelector('.b2b-bar');
    if (topbar) ROOT.style.setProperty('--b2b-bar-height', Math.ceil(topbar.getBoundingClientRect().height) + 'px');
    if (NAV.hidden) return;
    const picker = NAV.querySelector('.bp-mobile-nav');
    const h = picker && picker.getClientRects().length ? Math.max(0, Math.round(picker.getBoundingClientRect().top - NAV.getBoundingClientRect().top) - 8) : 0;
    NAV.style.setProperty('--bp-co-h', h + 'px');
  }

  // Opciones del selector: por cada grupo que administra, «Todos los hoteles · grupo» y sus
  // hoteles en un <optgroup>; después las empresas sueltas. Valor «g:<id>» para el grupo.
  function scopeOptions() {
    const inGroup = new Set();
    const opt = (value, label, on) => `<option value="${esc(value)}"${on ? ' selected' : ''}>${esc(label)}</option>`;
    const html = myGroups().map((g) => {
      const list = g.company_ids.map(companyById).filter(Boolean);
      list.forEach((c) => inGroup.add(c.id));
      return `<optgroup label="${esc(g.name)}">${opt('g:' + g.id, t('g_all_stores', { group: g.name }), S.groupId === g.id)}${
        list.map((c) => opt(c.id, c.name, c.id === S.companyId)).join('')}</optgroup>`;
    }).join('');
    return html + myCompanies().filter((c) => !inGroup.has(c.id)).map((c) => opt(c.id, c.name, c.id === S.companyId)).join('');
  }

  /* ---------- acceso ---------- */
  // Misma pantalla de acceso que la página de pedidos: la barra B2B (logo e idiomas) arriba y una
  // tarjeta con el título y el formulario.
  function mountGate(title) {
    ROOT.classList.add('is-gate');
    MAIN.innerHTML = `<section class="login-gate" aria-labelledby="lgTitle"><div class="lg-card">
      <h1 class="lg-title bp-title" id="lgTitle" tabindex="-1">${esc(title)}</h1>
      <div class="b2b-auth lg-auth" id="bpAuth" aria-live="polite"></div>
    </div></section>`;
  }

  function viewLogin() {
    const ar = B.authRedirect;
    mountGate(t('g_login_title'));
    B.renderAuthForm(MAIN.querySelector('#bpAuth'), {
      mode: ar && ar.error ? 'forgot' : 'login',
      notice: ar && ar.error ? t('auth_link_expired') : '',
      noticeKind: 'err',
      autofocus: false,
      onDone: async () => { await loadSession(); afterRender(render()); },
    });
  }

  async function viewReset() {
    // Enlace roto (sin tokens) o con error: nunca se ofrece cambiar la contraseña de una sesión que
    // ya estuviera abierta (podría ser de otra persona). Solo «pedir un enlace nuevo».
    const ar = B.authRedirect;
    const invalidLink = !!(ar && (ar.error || ar.noTokens));
    const session = invalidLink ? null : await B.getSession();
    const title = S.passwordMode === 'invite' ? t('auth_set_title') : t('auth_reset_title');
    mountGate(title);
    B.renderAuthForm(MAIN.querySelector('#bpAuth'), {
      mode: session ? 'set' : 'forgot',
      hideSub: !!session,
      notice: session ? '' : t(invalidLink ? 'auth_link_invalid' : 'auth_no_session'),
      noticeKind: 'err',
      onDone: async () => {
        B.toast(t('auth_pw_saved'), 'ok', { root: ROOT });
        S.passwordMode = null;
        await loadSession();
        B.cleanAuthUrl('#' + (S.afterPassword && S.afterPassword !== '/reset' ? S.afterPassword : '/'));
        afterRender(render());
      },
    });
    focusMain();
  }

  function viewChooseCompany() {
    const list = S.me.companies;
    const groups = myGroups();
    MAIN.innerHTML = `${h1(t('g_choose_company'))}
      <ul class="bp-list" role="list">${groups.map((g) => `
        <li><button type="button" class="bp-row bp-row--btn" data-co="g:${esc(g.id)}">
          <span class="bp-row-main"><strong>${esc(t('g_all_stores', { group: g.name }))}</strong><span class="bp-muted">${esc(t('p_group'))}</span></span>
          <span class="bp-row-go" aria-hidden="true">${ICON.chev}</span>
        </button></li>`).join('')}${list.map((c) => `
        <li><button type="button" class="bp-row bp-row--btn" data-co="${esc(c.id)}">
          <span class="bp-row-main"><strong>${esc(c.name)}</strong>${c.legal_name && c.legal_name !== c.name ? `<span class="bp-muted">${esc(c.legal_name)}</span>` : ''}</span>
          <span class="bp-row-go" aria-hidden="true">${ICON.chev}</span>
        </button></li>`).join('')}</ul>`;
    MAIN.querySelectorAll('[data-co]').forEach((b) => b.addEventListener('click', () => { setScope(b.dataset.co); render(); }));
    focusMain();
  }

  function viewNotFound() {
    MAIN.innerHTML = h1(t('g_not_found')) + empty('', `<a class="b2b-btn b2b-btn--primary" href="#/">${esc(t('g_go_home'))}</a>`);
    focusMain();
  }

  /* ---------- datos ---------- */
  // Caché ligada al ámbito activo (empresa o grupo): una respuesta que llega tarde (tras cambiar)
  // nunca se guarda en la caché del otro, y cada carga usa el ámbito capturado al empezar.
  async function companyCached(key, load, force) {
    const cache = S.cache;
    const companyId = S.companyId;
    const groupId = S.groupId;
    const company = S.company;
    const ids = scopeIds();
    if (!force && cache[key] != null) return cache[key];
    const value = await load(companyId, company, ids);
    if (S.cache === cache && S.companyId === companyId && S.groupId === groupId) cache[key] = value;
    return value;
  }
  // filtro por empresa: una (eq) o las del grupo (in); sin empresas no se pide nada a otra empresa
  const byCompany = (query, ids, col = 'company_id') => (ids.length === 1 ? query.eq(col, ids[0]) : query.in(col, ids));
  const withHotel = (rows) => { if (S.groupId) rows.forEach((r) => { r.company_name = companyName(r.company_id); }); return rows; };
  function loadRequests(force) {
    return companyCached('requests', async (companyId, company, ids) => {
      if (!ids.length) return [];
      const rows = withHotel(await q(() => byCompany(sb().from('portal_requests')
        .select('id,ref,company_id,season,status,turn,current_version,approved_version,delivery_store_ids,buyer_po,created_at,updated_at'), ids)
        .order('updated_at', { ascending: false }).limit(200)));
      const reqIds = rows.filter((r) => r.current_version > 0).map((r) => r.id);
      const totals = new Map();
      if (reqIds.length) {
        const vs = await q(() => sb().from('portal_request_versions').select('request_id,version,units,total,currency').in('request_id', reqIds));
        vs.forEach((v) => { const r = rows.find((x) => x.id === v.request_id); if (r && v.version === r.current_version) totals.set(v.request_id, v); });
      }
      rows.forEach((r) => { const v = totals.get(r.id); r.units = v ? v.units : null; r.total = v ? v.total : null; r.currency = v ? v.currency : 'EUR'; });
      return rows;
    }, force);
  }
  // Un pedido cancelado sin unidades (p. ej. un duplicado anulado en el CRM) no le dice nada al cliente:
  // solo lo ve SES (administrador, también en «Ver como…»).
  const visibleOrder = (o) => isAdmin() || !(o.status === 'CANCELLED' && !(o.units > 0));
  function loadOrders() {
    return companyCached('orders', async (companyId, company, ids) => (ids.length ? withHotel(await q(() => byCompany(sb().from('portal_orders')
      .select('id,ref,company_id,season,ordered_at,status,units,amount,currency'), ids)
      .order('ordered_at', { ascending: false }).limit(300))).filter(visibleOrder) : []));
  }
  function loadOrderLines(id) {
    return companyCached('lines:' + id, () => q(() => sb().from('portal_order_lines')
      .select('sku,style_code,style_name,color,size,units,units_shipped').eq('order_id', id)));
  }
  function loadDocs() {
    return companyCached('docs', async (companyId, company, ids) => {
      const docIds = ids.filter((id) => (companyById(id) || {}).can_see_documents);
      if (!docIds.length) return [];
      return withHotel(await B.selectAll(() => byCompany(sb().from('portal_documents')
        .select('id,company_id,doc_type,number,issued_at,season,amount,currency,status,related_number'), docIds)
        .order('issued_at', { ascending: false }).order('id')));
    });
  }
  // Tarifa de la empresa elegida o, en la vista de grupo, de todas sus empresas (rows con company_id).
  function loadPrices() {
    return companyCached('prices', async (companyId, company, ids) => {
      const stores = scopeCompanies().flatMap((c) => c.stores || []);
      const countries = [...new Set(stores.map((st) => st.country_code).filter(Boolean))];
      if (!ids.length) return { rows: [], rrp: [], countries, models: [], modelsByCompany: {} };
      const rows = await B.selectAll(() => byCompany(sb().from('portal_prices')
        .select('company_id,sku,style_code,wholesale,deposit,currency'), ids).eq('season', SEASON).order('sku').order('company_id'));
      // Modelos de venta por empresa ('{}' = proyección antigua: un solo precio sin rótulo).
      const cos = await q(() => byCompany(sb().from('portal_companies').select('id,sale_models'), ids, 'id'));
      const modelsByCompany = {};
      (cos || []).forEach((c) => { modelsByCompany[c.id] = c.sale_models || []; });
      // Una empresa: sus modelos; varias (vista de grupo): la unión, para rotular la tabla común.
      const models = [...new Set(ids.flatMap((id) => modelsByCompany[id] || []))];
      const rrp = countries.length ? await B.selectAll(() => sb().from('portal_rrp')
        .select('country_code,sku,amount,currency,vat_included').eq('season', SEASON).in('country_code', countries)
        .order('country_code').order('sku')) : [];
      return { rows, rrp, countries, models, modelsByCompany };
    });
  }

  /* ---------- resumen ---------- */
  async function viewHome(seq) {
    const data = await guard(async () => {
      const [reqs, docs] = await Promise.all([
        loadRequests(),
        canDocs() ? loadDocs() : Promise.resolve([]),
      ]);
      return { reqs, docs };
    }, render);
    if (!data || stale(seq)) return;
    const open = data.reqs.filter((r) => ['SUBMITTED', 'CHANGES_PROPOSED', 'COUNTER', 'DRAFT'].includes(r.status))
      .sort((a, b) => (b.turn === 'BUYER') - (a.turn === 'BUYER') || String(b.updated_at).localeCompare(String(a.updated_at)));
    const lastDocs = data.docs.slice(0, 3);
    // Cliente nuevo (nada en curso, sin historial ni documentos): la colección ocupa el resumen.
    const fresh = !data.reqs.length && !data.docs.length;
    MAIN.innerHTML = `
      ${h1(t('p_home'), S.me.last_sync ? esc(t('p_updated', { date: B.fmtDateTime(S.me.last_sync) })) : '')}
      ${collectionBlock(fresh)}
      ${fresh ? '' : `
      <section class="bp-section" aria-labelledby="bpCur">
        <div class="bp-h2-row"><h2 class="bp-h2" id="bpCur">${esc(t('p_current'))}</h2><a class="b2b-link" href="#/pedidos">${esc(t('p_see_orders'))}</a></div>
        ${open.length ? `<ul class="bp-list" role="list">${open.map(requestRow).join('')}</ul>` : empty(t('p_no_current'))}
      </section>
      ${canDocs() ? `
      <section class="bp-section" aria-labelledby="bpDocs">
        <div class="bp-h2-row"><h2 class="bp-h2" id="bpDocs">${esc(t('p_last_docs'))}</h2>${lastDocs.length ? `<a class="b2b-link" href="#/documentos">${esc(t('p_all_docs'))}</a>` : ''}</div>
        ${lastDocs.length ? `<ul class="bp-list" role="list">${lastDocs.map(docRow).join('')}</ul>` : empty(t('p_no_docs'))}
      </section>` : ''}`}`;
    wireDocButtons(MAIN);
    wireNewOrder(MAIN);
    focusMain();
  }

  // Colección de la temporada: la puerta de entrada al catálogo (página de pedidos), al lookbook y a los precios.
  // `hero`: grande, con foto, para quien aún no tiene pedidos; si no, compacta encima de sus pedidos.
  function collectionBlock(hero) {
    const img = CFG.graciasImg || {};
    const brand = ((window.SES_DATA || {}).config || {}).brand || {};
    const lookbook = (((window.SES_DATA || {}).config || {}).links || {}).lookbook;
    const lb = /^https:\/\//.test(lookbook || '') ? lookbook : '';
    return `
      <section class="bp-section bp-coll${hero ? ' bp-coll--hero' : ''}" aria-labelledby="bpColl">
        ${img.src ? `<div class="bp-coll-media"><img src="${esc(img.src)}"${img.srcset ? ` srcset="${esc(img.srcset)}" sizes="(min-width: 900px) 40vw, 100vw"` : ''} alt="" loading="lazy" decoding="async"></div>` : ''}
        <div class="bp-coll-body">
          ${brand.seasonLabel ? `<p class="bp-coll-kicker">${esc(brand.seasonLabel)}</p>` : ''}
          <h2 class="bp-h2 bp-coll-title" id="bpColl">${esc(t('p_coll_title', { season: SEASON }))}</h2>
          <p class="bp-note">${esc(t('p_coll_text'))}</p>
          <div class="bp-quick">
            ${newOrderButton(true, t('p_coll_go'), true)}
            ${lb ? `<a class="b2b-btn b2b-btn--secondary" href="${esc(lb)}" target="_blank" rel="noopener">${esc(t('p_lookbook'))} ↗</a>` : ''}
            <a class="b2b-btn b2b-btn--secondary" href="#/tarifa">${esc(t('p_see_prices'))}</a>
          </div>
        </div>
      </section>`;
  }

  // «Hacer pedido»: con una empresa, enlace directo; en la vista de grupo primero se elige el hotel
  // (cada pedido es de una empresa: se factura a ella y se entrega en su tienda).
  // `browse`: sin permiso de pedido, el enlace sigue llevando a ver la colección.
  function newOrderButton(icon, label, browse) {
    if (!canOrderAny() && !browse) return '';
    const inner = `${icon ? ICON.bag : ''}<span>${esc(label || t('p_new_order', { season: SEASON }))}</span>`;
    if (!canOrderAny()) return `<a class="b2b-btn b2b-btn--primary" href="${esc(ORDER_URL)}">${inner}</a>`;
    if (!S.groupId) return `<a class="b2b-btn b2b-btn--primary" href="${esc(ORDER_URL)}">${inner}</a>`;
    return `<button type="button" class="b2b-btn b2b-btn--primary" data-new-order>${inner}</button>`;
  }
  function wireNewOrder(root) {
    root.querySelectorAll('[data-new-order]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); pickHotelAndOrder(); }));
  }
  async function pickHotel(list) {
    if (list.length === 1) return list[0].id;
    const choice = await B.dialog({
      root: ROOT, title: t('g_pick_hotel'),
      body: `<p class="b2b-dialog-text">${esc(t('g_pick_hotel_t'))}</p>`,
      actions: [{ id: '', label: t('cancel'), kind: 'ghost' }].concat(list.map((c) => ({ id: c.id, label: c.name, kind: 'secondary' }))),
    });
    return choice || null;
  }
  async function pickHotelAndOrder() {
    const id = await pickHotel(scopeCompanies().filter((c) => c.can_order));
    if (!id) return;
    // la página de pedidos abre con esa empresa; el portal sigue en la vista de grupo al volver
    B.chooseCompany(id);
    location.assign(ORDER_URL);
  }

  function requestRow(r) {
    const href = '#/' + (isAdminView() ? 'admin' : 'pedidos') + '/' + encodeURIComponent(r.id);
    const company = r.company_name ? `<span class="bp-muted">${esc(r.company_name)}</span>` : '';
    const meta = [r.season, r.units != null ? units(r.units) : '', r.total != null ? money(r.total, r.currency) : '', B.fmtDate(r.updated_at)].filter(Boolean).join(' · ');
    return `<li><a class="bp-row" href="${href}">
      <span class="bp-row-main">
        <span class="bp-row-title"><strong>${esc(r.ref)}</strong>${company}</span>
        <span class="bp-row-meta u-tnum">${esc(meta)}</span>
      </span>
      <span class="bp-row-side">${stateChip(r, isAdminView())}</span>
      <span class="bp-row-go" aria-hidden="true">${ICON.chev}</span>
    </a></li>`;
  }

  /* ---------- pedidos ---------- */
  async function viewOrders(seq, opts) {
    const data = await guard(async () => {
      const [reqs, orders] = await Promise.all([loadRequests(), loadOrders()]);
      return { reqs, orders };
    }, render);
    if (!data || stale(seq)) return;
    const seasons = [...new Set([SEASON, ...data.reqs.map((r) => r.season), ...data.orders.map((o) => o.season)].filter(Boolean))]
      .sort((a, b) => seasonKey(b) - seasonKey(a));
    const cur = S.ordersSeason && seasons.includes(S.ordersSeason) ? S.ordersSeason : seasons[0];
    S.ordersSeason = cur;
    const reqs = data.reqs.filter((r) => r.season === cur);
    const orders = data.orders.filter((o) => o.season === cur);
    MAIN.innerHTML = `
      ${h1(t('p_orders'))}
      <div class="bp-seasons" role="group" aria-label="${esc(t('p_season'))}">
        ${seasons.map((s) => `<button type="button" class="bp-chip" aria-pressed="${s === cur}" data-season="${esc(s)}">${esc(s)}</button>`).join('')}
      </div>
      <section class="bp-section" aria-labelledby="bpReq">
        <h2 class="bp-h2" id="bpReq">${esc(t('p_portal_reqs'))}</h2>
        ${reqs.length ? `<ul class="bp-list" role="list">${reqs.map(requestRow).join('')}</ul>`
          : empty(t('p_no_reqs'), cur === SEASON ? newOrderButton(false) : '')}
      </section>
      <section class="bp-section" aria-labelledby="bpHist">
        <h2 class="bp-h2" id="bpHist">${esc(t('p_history'))}</h2>
        ${orders.length ? `<ul class="bp-list" role="list">${orders.map(orderRow).join('')}</ul>` : empty(t('p_no_history'))}
      </section>`;
    // cambiar de temporada repinta en el sitio: sin esqueleto, sin saltar arriba y con el foco en el botón
    MAIN.querySelectorAll('[data-season]').forEach((b) => b.addEventListener('click', async () => {
      S.ordersSeason = b.dataset.season;
      const y = window.scrollY;
      await viewOrders(S.renderSeq, { keepFocus: b.dataset.season });
      window.scrollTo(0, y);
    }));
    MAIN.querySelectorAll('[data-lines]').forEach((b) => b.addEventListener('click', () => toggleOrderLines(b)));
    MAIN.querySelectorAll('[data-repeat]').forEach((b) => b.addEventListener('click', () => repeatHistoric(b.dataset.repeat, b)));
    wireNewOrder(MAIN);
    // descargar pedido, envíos y «Recepcionar» (ses-b2b-fulfil.js)
    if (B.portalFulfil && orders.length) {
      B.portalFulfil.enhanceOrders({ root: ROOT, MAIN, orders, loadOrderLines, lineLabel, rerender: render,
        companyById: (id) => companyById(id) || (S.company && S.company.id === id ? S.company : null) });
    }
    const keep = opts && opts.keepFocus && MAIN.querySelector(`[data-season="${CSS.escape(opts.keepFocus)}"]`);
    if (keep) keep.focus({ preventScroll: true }); else focusMain();
  }
  function seasonKey(s) {
    const m = /^(SS|AW|FW)(\d{2})$/i.exec(s || '');
    return m ? Number(m[2]) * 10 + (m[1].toUpperCase() === 'SS' ? 0 : 5) : 0;
  }

  function orderRow(o) {
    const meta = [o.ordered_at ? B.fmtDate(o.ordered_at) : '', units(o.units), o.amount != null ? money(o.amount, o.currency) : ''].filter(Boolean).join(' · ');
    return `<li class="bp-order" data-order="${esc(o.id)}">
      <div class="bp-row bp-row--static">
        <span class="bp-row-main">
          <span class="bp-row-title"><strong>${esc(o.ref)}</strong>${o.company_name ? `<span class="bp-muted">${esc(o.company_name)}</span>` : ''}</span>
          <span class="bp-row-meta u-tnum">${esc(meta)}</span>
        </span>
        <span class="bp-row-side">${badge(t('os_' + o.status), o.status === 'CANCELLED' ? 'muted' : (o.status === 'INVOICED' || o.status === 'CLOSED' ? 'ok' : 'neutral'))}</span>
      </div>
      <div class="bp-order-actions">
        <button type="button" class="b2b-btn b2b-btn--ghost" data-lines="${esc(o.id)}" aria-expanded="false" aria-controls="ol-${esc(o.id)}">${esc(t('p_show_lines'))}</button>
        ${(companyById(o.company_id) || S.company || {}).can_order ? `<button type="button" class="b2b-btn b2b-btn--secondary" data-repeat="${esc(o.id)}">${ICON.repeat}<span>${esc(t('p_repeat'))}</span></button>` : ''}
      </div>
      <div class="bp-order-lines" id="ol-${esc(o.id)}" hidden></div>
    </li>`;
  }

  /* ---------- reportar ventas (depósito / bill-and-hold): la vista vive en ses-b2b-sellout.js ---------- */
  function viewSales(seq) {
    if (!B.portalSellout || !sellStoresInScope()) return viewNotFound();
    return B.portalSellout.view(seq, { MAIN, ROOT, guard, stale, focusMain, scopeCompanies, companyById, lineLabel, rerender: render });
  }

  /* ---------- análisis (histórico y sell-through): la vista vive en ses-b2b-analytics.js ---------- */
  function viewAnalytics(seq) {
    if (!B.portalAnalytics) return viewNotFound();
    return B.portalAnalytics.view(seq, {
      MAIN, companyId: S.companyId, companyIds: scopeIds(), guard, retry: render, q, sb, stale, focusMain, thumb: catalogThumb,
    });
  }

  async function toggleOrderLines(btn) {
    const box = MAIN.querySelector('#ol-' + CSS.escape(btn.dataset.lines));
    const open = btn.getAttribute('aria-expanded') === 'true';
    if (open) { box.hidden = true; btn.setAttribute('aria-expanded', 'false'); btn.textContent = t('p_show_lines'); return; }
    box.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    btn.textContent = t('p_hide_lines');
    box.innerHTML = `<div class="bp-skel-card" aria-hidden="true"></div>`;
    try {
      const lines = await loadOrderLines(btn.dataset.lines);
      box.innerHTML = linesTable(lines.map((l) => ({ sku: l.sku, qty: l.units, shipped: l.units_shipped, style_name: l.style_name, style_code: l.style_code, color: l.color, size: l.size })), { shipped: true });
    } catch (e) {
      box.innerHTML = `<p class="bp-error-inline">${esc(B.errorMessage(B.errorCode(e)))}</p>`;
    }
  }

  // Tabla de líneas agrupada por estilo · color con las tallas en columnas.
  function linesTable(lines, opts) {
    const o = opts || {};
    const rows = lines.filter((l) => (l.qty || 0) > 0).map((l) => Object.assign({}, l, lineLabel(l)))
      .sort((a, b) => a.name.localeCompare(b.name) || a.color.localeCompare(b.color) || sizeOrder(a.size) - sizeOrder(b.size));
    if (!rows.length) return `<p class="bp-muted">${esc(t('err_empty_order'))}</p>`;
    return `<div class="bp-table-wrap"><table class="bp-table">
      <thead><tr><th scope="col">${esc(t('d_item'))}</th><th scope="col" class="num">${esc(t('d_qty'))}</th>
        ${o.prices ? `<th scope="col" class="num bp-hide-xs">${esc(t('d_price'))}</th><th scope="col" class="num">${esc(t('d_amount'))}</th>` : ''}</tr></thead>
      <tbody>${rows.map((l) => `<tr>
        <td><span class="bp-item">${l.hex ? `<i class="bp-dot" style="background:${B.safeHex(l.hex)}"></i>` : ''}<span><strong>${esc(l.name)}</strong> <span class="bp-muted">${esc(l.color)} · ${esc(l.size)}</span>${o.prices ? `<span class="bp-line-unit u-tnum">${esc(t('d_price'))} ${esc(B.fmtPrice(l.unit_price, o.currency))}</span>` : ''}${l.comment ? `<span class="bp-line-note">${esc(l.comment)}</span>` : ''}</span></span></td>
        <td class="num u-tnum">${B.fmtInt(l.qty)}${o.shipped && l.shipped != null ? ` <span class="bp-muted">(${B.fmtInt(l.shipped)} ${esc(t('p_shipped'))})</span>` : ''}</td>
        ${o.prices ? `<td class="num u-tnum bp-hide-xs">${esc(B.fmtPrice(l.unit_price, o.currency))}</td><td class="num u-tnum">${esc(money(l.qty * l.unit_price, o.currency))}</td>` : ''}
      </tr>`).join('')}</tbody>
      ${o.total != null ? `<tfoot><tr><th scope="row">${esc(t('d_total'))}</th><td class="num u-tnum">${B.fmtInt(o.units)}</td>${o.prices ? `<td class="bp-hide-xs"></td><td class="num u-tnum"><strong>${esc(money(o.total, o.currency))}</strong></td>` : ''}</tr></tfoot>` : ''}
    </table></div>`;
  }
  function sizeOrder(s) {
    const i = ['XS', 'S', 'S/M', 'M', 'M/L', 'L', 'XL', 'XXL', 'U', 'Única'].indexOf(s);
    return i < 0 ? 99 : i;
  }

  /* ---------- detalle de un pedido web (versiones, diferencias y acciones) ---------- */
  async function loadRequestDetail(id) {
    const reqSel = 'id,ref,company_id,season,status,turn,current_version,approved_version,delivery_store_ids,buyer_po,created_at,updated_at,portal_companies(name)';
    const rows = await q(() => sb().from('portal_requests').select(reqSel).eq('id', id).limit(1));
    const r = rows && rows[0];
    if (!r) return null;
    const [versions, events] = await Promise.all([
      q(() => sb().from('portal_request_versions').select('version,author_role,lines,units,total,currency,comment,created_at').eq('request_id', id).order('version', { ascending: true })),
      q(() => sb().from('portal_request_events').select('action,version,actor_role,at').eq('request_id', id).order('at', { ascending: true })),
    ]);
    let stores = [];
    if ((r.delivery_store_ids || []).length) {
      stores = await q(() => sb().from('portal_stores').select('id,name,country_code').in('id', r.delivery_store_ids));
    }
    return { r, versions, events, stores };
  }

  async function viewRequest(seq) {
    const id = S.route.id;
    const d = await guard(() => loadRequestDetail(id), render);
    if (stale(seq)) return;
    if (!d) { if (!MAIN.querySelector('.bp-error')) viewNotFound(); return; }
    paintRequest(d);
  }

  function diffLines(prev, cur) {
    const a = new Map((prev || []).map((l) => [l.sku, l]));
    const b = new Map((cur || []).map((l) => [l.sku, l]));
    const skus = [...new Set([...a.keys(), ...b.keys()])];
    return skus.map((sku) => {
      const p = a.get(sku); const c = b.get(sku);
      const before = p ? p.qty : 0; const now = c ? c.qty : 0;
      const kind = !p ? 'new' : !c || now === 0 ? 'removed' : now > before ? 'up' : now < before ? 'down' : 'same';
      return Object.assign({ sku, before, now, kind, comment: c && c.comment }, lineLabel(c || p));
    }).sort((x, y) => x.name.localeCompare(y.name) || x.color.localeCompare(y.color) || sizeOrder(x.size) - sizeOrder(y.size));
  }

  function diffTable(rows, showSame) {
    const vis = rows.filter((r) => showSame || r.kind !== 'same');
    if (!vis.length) return `<p class="bp-muted">${esc(t('d_no_changes'))}</p>`;
    const kindBadge = { up: [ICON.up, 'd_up'], down: [ICON.down, 'd_down'], removed: [ICON.x, 'd_removed'], new: [ICON.plus, 'd_new'], same: ['', ''] };
    return `<div class="bp-table-wrap"><table class="bp-table bp-diff">
      <thead><tr><th scope="col">${esc(t('d_item'))}</th><th scope="col" class="num">${esc(t('d_before'))}</th><th scope="col" class="num">${esc(t('d_now'))}</th><th scope="col">${esc(t('d_change'))}</th></tr></thead>
      <tbody>${vis.map((r) => `<tr class="bp-diff--${r.kind}">
        <td><span class="bp-item">${r.hex ? `<i class="bp-dot" style="background:${B.safeHex(r.hex)}"></i>` : ''}<span><strong>${esc(r.name)}</strong> <span class="bp-muted">${esc(r.color)} · ${esc(r.size)}</span>${r.comment ? `<span class="bp-line-note">${esc(r.comment)}</span>` : ''}</span></span></td>
        <td class="num u-tnum">${r.kind === 'new' ? '<span class="bp-muted">0</span>' : B.fmtInt(r.before)}</td>
        <td class="num u-tnum"><strong>${B.fmtInt(r.now)}</strong></td>
        <td>${r.kind === 'same' ? '' : `<span class="bp-change bp-change--${r.kind}">${kindBadge[r.kind][0]}<span>${esc(t(kindBadge[r.kind][1]))}</span></span>`}</td>
      </tr>`).join('')}</tbody></table></div>`;
  }

  function paintRequest(d) {
    const { r, versions, events } = d;
    const admin = isAdmin() && (S.route.admin || !S.companyId || r.company_id !== S.companyId);
    S.adminDetail = admin;
    const cur = versions[versions.length - 1] || null;
    const prev = versions.length > 1 ? versions[versions.length - 2] : null;
    const cancelEv = r.status === 'CANCELLED' ? (events.slice().reverse().find((e) => /^cancelled_by_/.test(e.action)) || {}).action : null;
    const myTurn = admin ? r.turn === 'SES' : r.turn === 'BUYER';
    const reqCompany = companyById(r.company_id);
    const canOrder = admin || !!(reqCompany && reqCompany.can_order);
    const back = admin ? `<a class="bp-back" href="#/admin">${ICON.arrowLeft}<span>${esc(t('p_back_inbox'))}</span></a>`
      : `<a class="bp-back" href="#/pedidos">${ICON.arrowLeft}<span>${esc(t('p_back_orders'))}</span></a>`;
    const roleName = (role) => role === 'SES' ? t('d_by_ses') : (admin ? t('d_by_customer') : t('d_by_you'));
    const editing = S.editing && S.editing.requestId === r.id;

    let actions = '';
    if (!editing && canOrder) {
      const btns = [];
      if (!admin && r.status === 'CHANGES_PROPOSED' && myTurn) {
        btns.push(`<button type="button" class="b2b-btn b2b-btn--primary" data-act="accept">${ICON.check}<span>${esc(t('d_accept'))}</span></button>`);
        btns.push(`<button type="button" class="b2b-btn b2b-btn--secondary" data-act="counter">${esc(t('d_counter'))}</button>`);
      }
      if (admin && ['SUBMITTED', 'COUNTER'].includes(r.status) && myTurn) {
        btns.push(`<button type="button" class="b2b-btn b2b-btn--primary" data-act="approve">${ICON.check}<span>${esc(t('d_approve'))}</span></button>`);
        btns.push(`<button type="button" class="b2b-btn b2b-btn--secondary" data-act="propose">${esc(t('d_propose'))}</button>`);
      }
      if (!admin && r.status === 'DRAFT') btns.push(`<a class="b2b-btn b2b-btn--primary" href="${esc(ORDER_URL)}" data-pick-co="${esc(r.company_id)}">${esc(t('d_continue'))}</a>`);
      if (!['APPROVED', 'CANCELLED'].includes(r.status)) btns.push(`<button type="button" class="b2b-btn b2b-btn--danger" data-act="cancel">${esc(t('d_cancel'))}</button>`);
      if (!admin && cur && ['APPROVED', 'CANCELLED'].includes(r.status) && reqCompany && reqCompany.can_order) {
        btns.push(`<button type="button" class="b2b-btn b2b-btn--secondary" data-act="repeat">${ICON.repeat}<span>${esc(t('p_repeat'))}</span></button>`);
      }
      actions = btns.length ? `<div class="bp-actions">${btns.join('')}</div>` : '';
    }

    const stores = d.stores.map((s) => `${s.name}${s.country_code ? ' (' + B.countryName(s.country_code) + ')' : ''}`).join(', ');
    const facts = [
      admin && r.portal_companies ? [t('p_company'), r.portal_companies.name] : null,
      !admin && S.groupId ? [t('col_store'), companyName(r.company_id)] : null,
      [t('p_season'), r.season],
      stores ? [t('d_delivery'), stores] : null,
      r.buyer_po ? [t('d_po'), r.buyer_po] : null,
    ].filter(Boolean);

    const timeline = versions.map((v) => `
      <li class="bp-tl-item${cur && v.version === cur.version ? ' is-current' : ''}">
        <span class="bp-tl-dot" aria-hidden="true"></span>
        <div class="bp-tl-body">
          <p class="bp-tl-head"><strong>${esc(t('d_version', { n: v.version }))}</strong> · ${esc(roleName(v.author_role))} · <span class="u-tnum">${esc(B.fmtDateTime(v.created_at))}</span></p>
          <p class="bp-tl-meta u-tnum">${esc(units(v.units))} · ${esc(money(v.total, v.currency))}</p>
          ${v.comment ? `<blockquote class="bp-tl-comment"><span class="bp-muted">${esc(t('d_comment'))}:</span> ${esc(v.comment)}</blockquote>` : ''}
        </div>
      </li>`).join('');

    const diffRows = prev && cur ? diffLines(prev.lines, cur.lines) : null;
    const showSame = !!S.showSame;

    MAIN.innerHTML = `
      ${back}
      <header class="bp-head bp-head--req">
        <div><h1 class="bp-title" tabindex="-1">${esc(r.ref)}</h1>
          <div class="bp-badges">${stateChip(r, admin, cancelEv)}</div>
        </div>
        ${cur ? `<p class="bp-head-total u-tnum"><strong>${esc(money(cur.total, cur.currency))}</strong><span>${esc(units(cur.units))} · ${esc(t('g_vat_excl'))}</span></p>` : ''}
      </header>
      <dl class="bp-facts">${facts.map(([k, v]) => `<div><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('')}</dl>
      ${actions}
      ${editing ? editorHtml(cur, admin) : ''}
      ${!editing && diffRows ? `
        <section class="bp-section" aria-labelledby="bpDiff">
          <div class="bp-h2-row"><h2 class="bp-h2" id="bpDiff">${esc(t('d_changes', { n: prev.version }))}</h2>
            <button type="button" class="b2b-link" id="bpSame" aria-pressed="${showSame}">${esc(t('d_show_all'))}</button></div>
          ${diffTable(diffRows, showSame)}
        </section>` : ''}
      ${!editing && cur ? `
        <section class="bp-section" aria-labelledby="bpLines">
          <h2 class="bp-h2" id="bpLines">${esc(t('d_lines_now', { n: cur.version }))}</h2>
          ${linesTable(cur.lines, { prices: true, currency: cur.currency, total: cur.total, units: cur.units })}
        </section>` : ''}
      ${versions.length ? `
        <section class="bp-section" aria-labelledby="bpTl">
          <h2 class="bp-h2" id="bpTl">${esc(t('d_versions'))}</h2>
          <ol class="bp-timeline">${timeline}</ol>
        </section>` : ''}`;

    const same = MAIN.querySelector('#bpSame');
    if (same) same.addEventListener('click', () => { S.showSame = !S.showSame; paintRequest(d); });
    MAIN.querySelectorAll('[data-act]').forEach((b) => b.addEventListener('click', () => onRequestAction(b.dataset.act, d, b)));
    // seguir un borrador desde la vista de grupo: la página de pedidos abre con la empresa del pedido
    MAIN.querySelectorAll('[data-pick-co]').forEach((a) => a.addEventListener('click', () => B.chooseCompany(a.dataset.pickCo)));
    if (editing) wireEditor(d, admin);
    focusMain();
  }


  function editorHtml(cur, admin) {
    const e = S.editing;
    const lines = (cur.lines || []).map((l) => Object.assign({}, l, lineLabel(l)))
      .sort((a, b) => a.name.localeCompare(b.name) || a.color.localeCompare(b.color) || sizeOrder(a.size) - sizeOrder(b.size));
    return `
      <section class="bp-section bp-editor" aria-labelledby="bpEd">
        <h2 class="bp-h2" id="bpEd">${esc(admin ? t('d_propose') : t('d_counter'))}</h2>
        <p class="bp-muted">${esc(t('d_edit_help'))}</p>
        <ul class="bp-edit-list" role="list">
          ${lines.map((l) => {
            const v = e.qty[l.sku] != null ? e.qty[l.sku] : l.qty;
            const changed = v !== l.qty;
            return `<li class="bp-edit-row${changed ? ' is-changed' : ''}" data-sku="${esc(l.sku)}">
              <span class="bp-item">${l.hex ? `<i class="bp-dot" style="background:${B.safeHex(l.hex)}"></i>` : ''}<span><strong>${esc(l.name)}</strong> <span class="bp-muted">${esc(l.color)} · ${esc(l.size)}</span>
                ${changed ? `<span class="bp-was u-tnum">${esc(t('d_before'))}: ${B.fmtInt(l.qty)}</span>` : ''}</span></span>
              <span class="bp-stepper">
                <button type="button" data-step="-1" aria-label="${esc(t('d_less'))}: ${esc(l.name)} ${esc(l.color)} ${esc(l.size)}">${ICON.minus}</button>
                <input type="text" inputmode="numeric" pattern="[0-9]*" maxlength="4" value="${v}" aria-label="${esc(t('d_qty'))}: ${esc(l.name)} ${esc(l.color)} ${esc(l.size)}" />
                <button type="button" data-step="1" aria-label="${esc(t('d_more'))}: ${esc(l.name)} ${esc(l.color)} ${esc(l.size)}">${ICON.plus}</button>
              </span>
              ${admin ? `<input class="b2b-input bp-line-comment" type="text" maxlength="500" placeholder="${esc(t('d_line_comment'))}" aria-label="${esc(t('d_line_comment'))}" value="${esc(e.comments[l.sku] || '')}" />` : ''}
            </li>`;
          }).join('')}
        </ul>
        <div class="b2b-field"><label class="b2b-label" for="bpEdComment">${esc(t('d_comment'))}</label>
          <textarea class="b2b-textarea" id="bpEdComment" maxlength="2000" placeholder="${esc(t('d_comment_ph'))}">${esc(e.comment || '')}</textarea></div>
        <p class="bp-error-inline" id="bpEdErr" role="alert" hidden></p>
        <div class="bp-actions">
          <button type="button" class="b2b-btn b2b-btn--primary" id="bpEdSend">${esc(admin ? t('d_send_propose') : t('d_send_counter'))}</button>
          <button type="button" class="b2b-btn b2b-btn--ghost" id="bpEdCancel">${esc(t('d_discard'))}</button>
        </div>
      </section>`;
  }

  function wireEditor(d, admin) {
    const e = S.editing;
    const cur = d.versions[d.versions.length - 1];
    const box = MAIN.querySelector('.bp-editor');
    box.querySelectorAll('.bp-edit-row').forEach((row) => {
      const sku = row.dataset.sku;
      const inp = row.querySelector('.bp-stepper input');
      const orig = (cur.lines.find((l) => l.sku === sku) || {}).qty || 0;
      const setV = (v) => {
        const n = Math.max(0, Math.min(9999, v));
        e.qty[sku] = n;
        inp.value = n;
        row.classList.toggle('is-changed', n !== orig);
      };
      row.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => setV((parseInt(inp.value, 10) || 0) + Number(b.dataset.step))));
      inp.addEventListener('input', () => setV(parseInt(inp.value.replace(/\D/g, '') || '0', 10)));
      const lc = row.querySelector('.bp-line-comment');
      if (lc) lc.addEventListener('input', () => { e.comments[sku] = lc.value; });
    });
    const cm = box.querySelector('#bpEdComment');
    cm.addEventListener('input', () => { e.comment = cm.value; });
    box.querySelector('#bpEdCancel').addEventListener('click', () => { S.editing = null; paintRequest(d); });
    box.querySelector('#bpEdSend').addEventListener('click', (ev) => sendEdit(d, admin, ev.currentTarget));
    const first = box.querySelector('.bp-stepper input');
    if (first) first.focus({ preventScroll: false });
  }

  async function sendEdit(d, admin, btn) {
    const e = S.editing;
    const cur = d.versions[d.versions.length - 1];
    const err = MAIN.querySelector('#bpEdErr');
    const lines = cur.lines.map((l) => ({
      sku: l.sku, color: l.color, size: l.size,
      qty: e.qty[l.sku] != null ? e.qty[l.sku] : l.qty,
      comment: admin ? (e.comments[l.sku] || null) : null,
    })).filter((l) => l.qty > 0);
    const changed = cur.lines.some((l) => (e.qty[l.sku] != null ? e.qty[l.sku] : l.qty) !== l.qty) || (admin && Object.values(e.comments).some(Boolean));
    if (!lines.length) { err.textContent = t('d_empty_lines'); err.hidden = false; return; }
    if (!changed && !(e.comment || '').trim()) { err.textContent = t('d_same'); err.hidden = false; return; }
    err.hidden = true;
    busy(btn, true);
    const fn = admin ? 'portal_propose' : 'portal_counter';
    const r = await B.rpc(fn, { p_request: d.r.id, p_expected_version: d.r.current_version, p_lines: lines, p_comment: (e.comment || '').trim() || null });
    busy(btn, false);
    if (r.error) return handleRpcError(r, d);
    S.editing = null;
    B.toast(t(admin ? 'd_done_propose' : 'd_done_counter'), 'ok', { root: ROOT });
    S.cache.requests = null;
    render();
  }

  function busy(btn, on) {
    if (!btn) return;
    btn.disabled = on;
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  }

  async function handleRpcError(r, d) {
    if (r.code === 'stale_version' || r.code === 'not_your_turn') {
      B.toast(B.errorMessage(r.code), 'err', { root: ROOT });
      S.editing = null;
      S.cache.requests = null;
      return render();
    }
    if (r.code === 'session_expired') { B.toast(B.errorMessage(r.code), 'err', { root: ROOT }); await B.signOut(); return null; }
    if (r.code === 'missing_price' && r.detail) {
      const l = lineLabel({ sku: r.detail });
      B.toast(B.errorMessage(r.code), 'err', { root: ROOT, list: [`${l.name} · ${l.color} · ${l.size}`] });
      return null;
    }
    B.toast(B.errorMessage(r.code), 'err', { root: ROOT });
    return d;
  }

  async function onRequestAction(act, d, btn) {
    const { r } = d;
    const cur = d.versions[d.versions.length - 1];
    const summary = cur ? { n: cur.version, units: units(cur.units), total: money(cur.total, cur.currency) } : {};
    if (act === 'counter' || act === 'propose') {
      S.editing = { requestId: r.id, version: r.current_version, qty: {}, comments: {}, comment: '' };
      paintRequest(d);
      return;
    }
    if (act === 'repeat') { repeatLines(cur.lines, r.season, btn, r.company_id); return; }
    if (act === 'accept' || act === 'approve') {
      const ok = await B.confirmDialog({
        root: ROOT, title: t(act === 'accept' ? 'd_accept_q' : 'd_approve_q'),
        text: t(act === 'accept' ? 'd_accept_t' : 'd_approve_t', summary),
        okLabel: t(act === 'accept' ? 'd_accept' : 'd_approve'),
      });
      if (!ok) return;
      busy(btn, true);
      const res = await B.rpc(act === 'accept' ? 'portal_accept' : 'portal_approve', { p_request: r.id, p_expected_version: r.current_version });
      busy(btn, false);
      if (res.error) { handleRpcError(res, d); return; }
      B.toast(t('d_done_accept'), 'ok', { root: ROOT });
      S.cache.requests = null;
      render();
      return;
    }
    if (act === 'cancel') {
      const body = document.createElement('div');
      body.innerHTML = `<p class="b2b-dialog-text">${esc(t('d_cancel_t'))}</p>
        <div class="b2b-field" style="margin-top:14px"><label class="b2b-label" for="bpReason">${esc(t('d_cancel_reason'))}</label>
        <textarea class="b2b-textarea" id="bpReason" maxlength="1000"></textarea></div>`;
      const choice = await B.dialog({
        root: ROOT, title: t('d_cancel_q'), body, alert: true,
        actions: [{ id: 'keep', label: t('d_keep'), kind: 'ghost' }, { id: 'cancel', label: t('d_cancel'), kind: 'danger' }],
      });
      if (choice !== 'cancel') return;
      const reason = (body.querySelector('#bpReason').value || '').trim();
      busy(btn, true);
      const res = await B.rpc('portal_cancel', { p_request: r.id, p_expected_version: r.current_version, p_reason: reason || null });
      busy(btn, false);
      if (res.error) { handleRpcError(res, d); return; }
      B.toast(t('d_done_cancel'), 'ok', { root: ROOT });
      S.cache.requests = null;
      render();
    }
  }

  /* ---------- repetir pedido: líneas → SKU actuales → borrador de la página de pedidos ---------- */
  function mapToCurrent(lines) {
    const ok = {};
    const missing = [];
    let all = 0; let avail = 0;
    lines.forEach((l) => {
      const qty = parseInt(l.qty != null ? l.qty : l.units, 10) || 0;
      if (qty <= 0) return;
      all += qty;
      let sku = SKU.has(l.sku) ? l.sku : null;
      if (!sku && l.style_code) sku = BY_KEY.get(`${l.style_code}|${norm(l.color)}|${norm(l.size)}`) || null;
      if (sku) { ok[sku] = (ok[sku] || 0) + qty; avail += qty; }
      else {
        const lab = lineLabel(l);
        missing.push(`${lab.name}${lab.color ? ' · ' + lab.color : ''}${lab.size ? ' · ' + lab.size : ''} (${qty})`);
      }
    });
    return { ok, missing, all, avail };
  }

  async function repeatHistoric(orderId, btn) {
    busy(btn, true);
    try {
      const lines = await loadOrderLines(orderId);
      const o = (S.cache.orders || []).find((x) => x.id === orderId) || {};
      await repeatLines(lines.map((l) => ({ sku: l.sku, qty: l.units, style_code: l.style_code, style_name: l.style_name, color: l.color, size: l.size })), o.season, btn, o.company_id);
    } catch (e) {
      B.toast(B.errorMessage(B.errorCode(e)), 'err', { root: ROOT });
    } finally { busy(btn, false); }
  }

  async function repeatLines(lines, fromSeason, btn, companyId) {
    // el borrador es de la empresa del pedido (en la vista de grupo, la del hotel de ese pedido)
    const coId = companyId || S.companyId;
    const m = mapToCurrent(lines || []);
    if (!m.avail) {
      B.toast(t('rp_nothing', { now: SEASON }), 'err', { root: ROOT, list: m.missing });
      return;
    }
    let existing = {};
    try { existing = (JSON.parse(B.ls.get(basketKey(coId)) || 'null') || {}).qty || {}; } catch (_) { existing = {}; }
    const existingUnits = Object.values(existing).reduce((s, n) => s + (parseInt(n, 10) || 0), 0);
    let qty = m.ok;
    if (existingUnits > 0) {
      const choice = await B.dialog({
        root: ROOT, title: t('rp_title'), alert: true,
        body: `<p class="b2b-dialog-text">${esc(t('rp_text', { units: units(existingUnits) }))}</p>`,
        actions: [{ id: 'cancel', label: t('cancel'), kind: 'ghost' }, { id: 'add', label: t('rp_add'), kind: 'secondary' }, { id: 'replace', label: t('rp_replace'), kind: 'primary' }],
      });
      if (!choice || choice === 'cancel') return;
      if (choice === 'add') {
        qty = Object.assign({}, existing);
        Object.keys(m.ok).forEach((sku) => { qty[sku] = (parseInt(qty[sku], 10) || 0) + m.ok[sku]; });
      }
    }
    // la página de pedidos lee este borrador al abrir (solo cantidades: nada personal)
    B.ls.set(basketKey(coId), JSON.stringify({ qty, ts: Date.now() }));
    if (coId !== S.companyId) B.chooseCompany(coId);
    const msg = t('rp_loaded', { season: fromSeason || '', ok: B.fmtInt(m.avail), all: B.fmtInt(m.all), now: SEASON }).replace(/^\s+/, '');
    B.ss.set(HANDOFF_KEY, JSON.stringify({ msg, list: m.missing.length ? [t('rp_unavail', { now: SEASON })].concat(m.missing) : [] }));
    if (btn) busy(btn, true);
    location.assign(ORDER_URL);
  }

  /* ---------- documentos ---------- */
  const DOC_TYPES = ['INVOICE', 'CREDIT_NOTE', 'DELIVERY_NOTE', 'PROFORMA'];
  function docRow(d) {
    const meta = [B.fmtDate(d.issued_at), d.season, d.amount != null ? money(d.amount, d.currency) : ''].filter(Boolean).join(' · ');
    const status = d.status ? badge(t('ds_' + d.status), d.status === 'PENDING' ? 'turn' : 'ok', d.status === 'PENDING' ? ICON.clock : ICON.check) : '';
    return `<li class="bp-doc">
      <span class="bp-doc-icon" aria-hidden="true">${ICON.doc}</span>
      <span class="bp-row-main">
        <span class="bp-row-title"><span class="bp-doc-type">${esc(t('doc_' + d.doc_type))}</span> <strong class="u-tnum">${esc(d.number)}</strong></span>
        <span class="bp-row-meta u-tnum">${d.company_name ? `${esc(d.company_name)} · ` : ''}${esc(meta)}${d.related_number ? ` · ${esc(t('doc_of', { n: d.related_number }))}` : ''}</span>
        ${status ? `<span class="bp-doc-status">${status}</span>` : ''}
      </span>
      <button type="button" class="b2b-btn b2b-btn--secondary bp-doc-dl" data-doc="${esc(d.id)}" data-num="${esc(d.number)}">${ICON.download}<span>${esc(t('doc_download'))}</span></button>
    </li>`;
  }

  function wireDocButtons(root) {
    root.querySelectorAll('[data-doc]').forEach((b) => b.addEventListener('click', () => downloadDoc(b.dataset.doc, b)));
  }

  async function downloadDoc(id, btn) {
    const label = btn.querySelector('span');
    const prev = label ? label.textContent : '';
    busy(btn, true);
    if (label) label.textContent = t('doc_downloading');
    // La pestaña se abre ya, dentro del clic (si no, el bloqueador de ventanas la frena tras el await).
    let win = null;
    try { win = window.open('', '_blank'); if (win) win.opener = null; } catch (_) { win = null; }
    try {
      // portal-doc-url vuelve a comprobar el acceso, registra la descarga (portal_log_download)
      // y devuelve una URL firmada de 60 s. La lectura directa del bucket está cerrada.
      const r = await B.invokeFn('portal-doc-url', { document_id: id });
      const url = r.data && r.data.url;
      if (!url) {
        if (win) win.close();
        B.toast(r.code && r.code !== 'unknown' ? B.errorMessage(r.code) : t('doc_fail'), 'err', { root: ROOT });
        return;
      }
      if (win) win.location.href = url;
      else window.location.assign(url);
    } catch (e) {
      if (win) win.close();
      B.toast(t('doc_fail'), 'err', { root: ROOT });
    } finally {
      busy(btn, false);
      if (label) label.textContent = prev;
    }
  }

  async function viewDocs(seq) {
    if (!canDocs()) { MAIN.innerHTML = h1(t('p_docs')) + empty(t('doc_no_access')); focusMain(); return; }
    const docs = await guard(loadDocs, render);
    if (!docs || stale(seq)) return;
    const f = S.docFilter || (S.docFilter = { type: 'all', season: '', q: '' });
    const seasons = [...new Set(docs.map((d) => d.season).filter(Boolean))].sort((a, b) => seasonKey(b) - seasonKey(a));
    const types = DOC_TYPES.filter((ty) => docs.some((d) => d.doc_type === ty));
    MAIN.innerHTML = `
      ${h1(t('p_docs'))}
      <div class="bp-filters">
        <div class="bp-chips" role="group" aria-label="${esc(t('p_docs'))}">
          ${['all'].concat(types).map((ty) => `<button type="button" class="bp-chip${f.type === ty ? ' is-active' : ''}" aria-pressed="${f.type === ty}" data-type="${ty}">${esc(ty === 'all' ? t('doc_all') : t('doc_f_' + ty))}</button>`).join('')}
        </div>
        <div class="bp-filter-row">
          ${seasons.length > 1 ? `<div class="b2b-field"><label class="b2b-label" for="bpDocSeason">${esc(t('p_season'))}</label>
            <select class="b2b-select" id="bpDocSeason"><option value="">${esc(t('doc_all_seasons'))}</option>${seasons.map((s) => `<option${s === f.season ? ' selected' : ''}>${esc(s)}</option>`).join('')}</select></div>` : ''}
          <div class="b2b-field"><label class="b2b-label" for="bpDocQ">${esc(t('doc_search'))}</label>
            <input class="b2b-input" id="bpDocQ" type="search" inputmode="search" autocomplete="off" placeholder="${esc(t('doc_search_ph'))}" value="${esc(f.q)}" /></div>
        </div>
      </div>
      <div id="bpDocList" aria-live="polite"></div>`;
    const paintList = () => {
      const qv = norm(f.q).replace(/\s+/g, '');
      const list = docs.filter((d) => (f.type === 'all' || d.doc_type === f.type) && (!f.season || d.season === f.season)
        && (!qv || norm(d.number).replace(/\s+/g, '').includes(qv) || norm(d.related_number).includes(qv)));
      const box = MAIN.querySelector('#bpDocList');
      box.innerHTML = !docs.length ? empty(t('p_no_docs'))
        : list.length ? `<ul class="bp-list" role="list">${list.map(docRow).join('')}</ul>`
          : empty(t('doc_none_filter'), `<button type="button" class="b2b-btn b2b-btn--secondary" id="bpDocClear">${esc(t('doc_clear'))}</button>`);
      wireDocButtons(box);
      const cl = box.querySelector('#bpDocClear');
      if (cl) cl.addEventListener('click', () => { S.docFilter = null; render(); });
    };
    MAIN.querySelectorAll('[data-type]').forEach((b) => b.addEventListener('click', () => {
      f.type = b.dataset.type;
      MAIN.querySelectorAll('[data-type]').forEach((x) => { const on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on); });
      paintList();
    }));
    const ss = MAIN.querySelector('#bpDocSeason');
    if (ss) ss.addEventListener('change', () => { f.season = ss.value; paintList(); });
    const qi = MAIN.querySelector('#bpDocQ');
    let tmr = null;
    qi.addEventListener('input', () => { clearTimeout(tmr); tmr = setTimeout(() => { f.q = qi.value; paintList(); }, 150); });
    paintList();
    focusMain();
  }

  /* ---------- tarifa ---------- */
  // Vista de grupo: ¿todas las empresas tienen exactamente el mismo precio por SKU esta temporada?
  // Misma tarifa en todas las empresas: mismo precio en firme y en depósito por SKU y mismos modelos de venta.
  function samePricesEverywhere(rows, ids, modelsByCompany) {
    const modelKey = (id) => [...((modelsByCompany && modelsByCompany[id]) || [])].sort().join(',');
    if (ids.some((id) => modelKey(id) !== modelKey(ids[0]))) return false;
    const per = new Map(ids.map((id) => [id, new Map()]));
    rows.forEach((r) => {
      if (per.has(r.company_id)) {
        per.get(r.company_id).set(r.sku, `${Number(r.wholesale).toFixed(2)}|${r.deposit == null ? '' : Number(r.deposit).toFixed(2)}|${r.currency}`);
      }
    });
    const maps = [...per.values()];
    if (!maps.length || !maps[0].size) return false;
    const [first, ...rest] = maps;
    return rest.every((m) => m.size === first.size && [...first].every(([sku, v]) => m.get(sku) === v));
  }

  async function viewPrices(seq) {
    const data = await guard(loadPrices, render);
    if (!data || stale(seq)) return;
    let rows = data.rows;
    let countries = data.countries;
    let models = data.models || [];
    let groupHead = '';
    if (S.groupId) {
      const list = scopeCompanies();
      const ids = list.map((c) => c.id);
      if (samePricesEverywhere(rows, ids, data.modelsByCompany)) {
        rows = rows.filter((r) => r.company_id === ids[0]);
        models = (data.modelsByCompany || {})[ids[0]] || [];
        groupHead = `<p class="bp-note">${esc(t('pr_same_all'))}</p>`;
      } else {
        if (!ids.includes(S.pricesCompany)) S.pricesCompany = list.length === 1 ? ids[0] : null;
        const pick = `<div class="bp-chips" role="group" aria-label="${esc(t('col_store'))}">${list.map((c) => `<button type="button" class="bp-chip${c.id === S.pricesCompany ? ' is-active' : ''}" aria-pressed="${c.id === S.pricesCompany}" data-price-co="${esc(c.id)}">${esc(c.name)}</button>`).join('')}</div>`;
        groupHead = `<p class="bp-note">${esc(t('pr_choose_store'))}</p>${pick}`;
        const chosen = companyById(S.pricesCompany);
        rows = chosen ? rows.filter((r) => r.company_id === chosen.id) : [];
        models = chosen ? ((data.modelsByCompany || {})[chosen.id] || []) : [];
        countries = chosen ? [...new Set((chosen.stores || []).map((st) => st.country_code).filter(Boolean))] : [];
        if (!chosen) {
          MAIN.innerHTML = `${h1(t('pr_title', { season: SEASON }), esc(t('pr_note')))}${groupHead}`;
          wirePriceCompany();
          focusMain();
          return;
        }
      }
    }
    const bySku = new Map(rows.map((r) => [r.sku, r]));
    const rrp = new Map();
    data.rrp.forEach((r) => { rrp.set(r.country_code + '|' + r.sku, r); });
    const styles = CATALOG.map((st) => {
      const skus = st.colors.flatMap((c) => c.sizes.map((s) => s.sku));
      const ws = skus.map((s) => bySku.get(s)).filter((p) => p && Number(p.wholesale) > 0);
      if (!ws.length) return null;
      const min = Math.min(...ws.map((p) => Number(p.wholesale)));
      const max = Math.max(...ws.map((p) => Number(p.wholesale)));
      const dep = ws.filter((p) => Number(p.deposit) > 0).map((p) => Number(p.deposit));
      const rr = countries.map((cc) => {
        const vals = skus.map((s) => rrp.get(cc + '|' + s)).filter((x) => x && Number(x.amount) > 0);
        if (!vals.length) return null;
        const mn = Math.min(...vals.map((x) => Number(x.amount)));
        const mx = Math.max(...vals.map((x) => Number(x.amount)));
        return { cc, min: mn, max: mx, cur: vals[0].currency, vat: vals[0].vat_included };
      });
      return { st, min, max, cur: ws[0].currency, rr, dmin: dep.length ? Math.min(...dep) : null, dmax: dep.length ? Math.max(...dep) : null };
    }).filter(Boolean);
    // Rótulo del precio principal según los modelos de la empresa; columna de
    // depósito solo si la empresa trabaja en firme y en depósito.
    // Mismo precio en firme y en depósito: el CRM no manda columna de depósito y se
    // muestra una sola columna con los dos modelos en el rótulo.
    const both = models.includes('FIRM') && models.includes('CONSIGNMENT');
    const showDeposit = both && styles.some((x) => x.dmin != null);
    const mainLabel = showDeposit ? t('pr_firm')
      : both ? t('pr_firm_or_deposit')
      : models.includes('FIRM') ? t('pr_firm')
      : models.includes('CONSIGNMENT') ? t('pr_deposit') : t('pr_wholesale');
    const fmtRange = (mn, mx, cur) => (mx > mn + 0.004 ? t('pr_range', { min: B.fmtPrice(mn, cur), max: B.fmtPrice(mx, cur) }) : B.fmtPrice(mn, cur));
    MAIN.innerHTML = `
      ${h1(t('pr_title', { season: SEASON }), esc(t('pr_note')) + (showDeposit ? ' ' + esc(t('pr_models_note')) : ''))}
      ${groupHead}
      ${!countries.length ? `<p class="bp-note">${esc(t('rrp_not_configured'))}</p>` : ''}
      ${styles.length ? `
        <div class="b2b-field bp-search"><label class="b2b-label" for="bpPrQ">${esc(t('pr_search'))}</label>
          <input class="b2b-input" id="bpPrQ" type="search" autocomplete="off" /></div>
        <div class="bp-table-wrap"><table class="bp-table bp-prices">
          <thead><tr><th scope="col">${esc(t('pr_style'))}</th><th scope="col" class="num">${esc(mainLabel)}</th>${showDeposit ? `<th scope="col" class="num">${esc(t('pr_deposit'))}</th>` : ''}
            ${countries.map((cc) => `<th scope="col" class="num">${esc(t('pr_rrp', { country: B.countryName(cc) }))}</th>`).join('')}</tr></thead>
          <tbody>${styles.map((x) => `<tr data-style="${esc(x.st.code)}" data-q="${esc(norm(x.st.name + ' ' + x.st.code + ' ' + x.st.colors.map((c) => c.name).join(' ')))}">
            <th scope="row"><span class="bp-item"><span class="bp-dots" aria-hidden="true">${x.st.colors.slice(0, 4).map((c) => `<i class="bp-dot" style="background:${B.safeHex(c.hex)}"></i>`).join('')}</span>
              <span><strong>${esc(x.st.name)}</strong> <span class="bp-muted">${esc(x.st.colors.length === 1 ? t('pr_colors_one') : t('pr_colors', { n: x.st.colors.length }))}</span></span></span></th>
            <td class="num u-tnum"><strong>${esc(fmtRange(x.min, x.max, x.cur))}</strong>${x.max > x.min + 0.004 ? `<span class="bp-muted bp-small"> ${esc(t('pr_varies'))}</span>` : ''}</td>
            ${showDeposit ? `<td class="num u-tnum">${x.dmin != null ? `<strong>${esc(fmtRange(x.dmin, x.dmax, x.cur))}</strong>` : '<span class="bp-muted">·</span>'}</td>` : ''}
            ${x.rr.map((r) => `<td class="num u-tnum">${r ? `${esc(fmtRange(r.min, r.max, r.cur))} <span class="bp-muted bp-small">${esc(r.vat ? t('g_vat_incl') : t('g_vat_excl'))}</span>` : `<span class="bp-muted bp-small">${esc(t('rrp_not_configured'))}</span>`}</td>`).join('')}
          </tr>`).join('')}</tbody>
        </table></div>
        <p class="bp-empty-inline" id="bpPrNone" hidden>${esc(t('pr_no_match'))}</p>`
      : empty(t('pr_none', { season: SEASON }))}`;
    const qi = MAIN.querySelector('#bpPrQ');
    if (qi) qi.addEventListener('input', () => {
      const v = norm(qi.value);
      let n = 0;
      MAIN.querySelectorAll('.bp-prices tbody tr[data-q]').forEach((tr) => { const show = !v || tr.dataset.q.includes(v); tr.hidden = !show; if (show) n++; });
      MAIN.querySelector('#bpPrNone').hidden = n > 0;
    });
    wirePriceCompany();
    // SKU/EAN por estilo y «Descargar tarifa» (ses-b2b-fulfil.js)
    if (B.portalFulfil && styles.length) {
      B.portalFulfil.enhancePrices({ MAIN, root: ROOT, catalog: CATALOG, styles, bySku, rrp, countries, showDeposit, mainLabel,
        company: (S.groupId ? companyById(S.pricesCompany) : null) || S.company, season: SEASON });
    }
    focusMain();
  }
  function wirePriceCompany() {
    MAIN.querySelectorAll('[data-price-co]').forEach((b) => b.addEventListener('click', () => {
      S.pricesCompany = b.dataset.priceCo;
      viewPrices(S.renderSeq);
    }));
  }

  /* ---------- datos de la empresa: facturación editable (con revisión de SES) ---------- */
  const BF = [ // campo, etiqueta, autocomplete, ancho completo
    ['legal_name', 'da_legal', 'organization', true],
    ['tax_id', 'da_tax', 'off', false],
    ['country', 'da_country', 'country', false],
    ['street', 'da_street', 'address-line1', true],
    ['number', 'da_number', 'address-line2', false],
    ['postcode', 'da_postcode', 'postal-code', false],
    ['city', 'da_city', 'address-level2', false],
    ['province', 'da_province', 'address-level1', false],
    ['contact_name', 'da_contact', 'name', false],
    ['email', 'da_email', 'email', false],
  ];
  const BF_LABEL = Object.fromEntries(BF.map(([k, l]) => [k, l]));

  function billingField([k, label, ac, wide], val) {
    const req = B.billing.REQUIRED.includes(k);
    const id = 'bf_' + k;
    const lab = `<label class="b2b-label" for="${id}">${esc(t(label))}${req ? ' <span aria-hidden="true">*</span>' : ''}</label>`;
    const hint = k === 'tax_id' ? `<p class="bp-bf-hint" id="${id}_hint">${esc(t('da_tax_hint'))}</p>` : '';
    const common = `id="${id}" name="${k}" autocomplete="${ac}"${req ? ' required aria-required="true"' : ''}${hint ? ` aria-describedby="${id}_hint"` : ''}`;
    let control;
    if (k === 'country') {
      control = `<select class="b2b-select" ${common}><option value="">${esc(t('da_pick_country'))}</option>${
        B.billing.countryOptions().map((c) => `<option value="${c.code}"${c.code === val ? ' selected' : ''}>${esc(c.name)}</option>`).join('')}</select>`;
    } else {
      const type = k === 'email' ? 'email' : 'text';
      const extra = k === 'tax_id' ? ' autocapitalize="characters" spellcheck="false"' : k === 'email' ? ' inputmode="email" spellcheck="false"' : '';
      control = `<input class="b2b-input" type="${type}" ${common} maxlength="${B.billing.MAX[k]}" value="${esc(val || '')}"${extra}>`;
    }
    return `<div class="b2b-field bp-bf${wide ? ' bp-bf--wide' : ''}" data-bf="${k}">${lab}${control}${hint}<p class="bp-bf-err" id="${id}_err" hidden></p></div>`;
  }

  function officialHtml(off) {
    const addr = [[off.street, off.number].filter(Boolean).join(' '), [off.postcode, off.city].filter(Boolean).join(' '), off.province].filter(Boolean).join(', ');
    const rows = [
      ['da_legal', off.legal_name], ['da_tax', off.tax_id, 'u-tnum'], ['da_address', addr],
      ['da_country', off.country ? B.countryName(off.country) : off.countryText], ['da_contact', off.contact_name], ['da_email', off.email],
    ].filter((r) => r[1]);
    if (!rows.length) return `<p class="bp-note">${esc(t('da_none'))}</p>`;
    return `<dl class="bp-facts bp-facts--stack">${rows.map(([l, v, c]) => `<div><dt>${esc(t(l))}</dt><dd${c ? ` class="${c}"` : ''}>${esc(v)}</dd></div>`).join('')}</dl>`;
  }

  async function viewDetails(seq) {
    if (S.groupId) return viewGroupDetails(seq);
    const co = await guard(async () => {
      const rows = await q(() => sb().from('portal_companies').select('id,name,legal_name,tax_id').eq('id', S.companyId).limit(1));
      return rows[0] || { name: S.company.name };
    }, render);
    if (!co || stale(seq)) return;
    const st = await B.billing.state(S.companyId, true);
    if (stale(seq)) return;
    const company = (st && st.company) || co;
    const off = B.billing.officialDetails(company);
    off.countryText = company.billing_country || '';
    const reqRow = st && st.request;
    const stores = S.company.stores || [];
    const mail = `mailto:antonio@sespalma.com?subject=${encodeURIComponent('Cambio de datos · ' + (co.name || ''))}`;
    const yn = (v) => (v ? t('da_yes') : t('da_no'));
    const viewAs = !!S.company.view_as;
    const canEdit = !!S.company.can_order && !viewAs;
    // estado de la última solicitud
    let status = '';
    if (st && st.pending && reqRow && reqRow.status === 'PENDING') {
      status = `<div class="bp-bf-status" role="status" tabindex="-1" id="bpBfStatus"><p><strong>${esc(t('da_received'))}</strong></p>
        <p>${esc(t('da_received_on', { date: B.fmtDateTime(reqRow.submitted_at) }))}</p></div>`;
    } else if (st && st.pending) {
      status = `<div class="bp-bf-status" role="status" tabindex="-1" id="bpBfStatus"><p>${esc(t('da_applied_wait'))}</p></div>`;
    } else if (reqRow && reqRow.status === 'REJECTED' && st && st.incomplete) {
      status = `<div class="bp-bf-status bp-bf-status--warn" role="status" tabindex="-1" id="bpBfStatus"><p>${esc(t('da_rejected'))}</p>
        ${reqRow.ses_note ? `<p>${esc(t('da_ses_note', { note: reqRow.ses_note }))}</p>` : ''}</div>`;
    } else if (st && st.incomplete) {
      status = `<p class="bp-bf-missing">${esc(t('da_missing', { list: st.missing.map((k) => t(BF_LABEL[k] || k)).join(', ') }))}</p>`;
    }
    // prefijado: lo enviado si sigue abierto o rechazado; si no, los datos oficiales
    const pre = reqRow && reqRow.details && reqRow.status !== 'APPLIED' ? Object.assign(B.billing.officialDetails({}), reqRow.details)
      : reqRow && reqRow.details && st && st.pending ? Object.assign(B.billing.officialDetails({}), reqRow.details) : off;
    const openForm = canEdit && (S.billOpen === S.companyId || !st || st.incomplete || (reqRow && reqRow.status === 'PENDING'));
    const form = !canEdit ? `<p class="bp-note">${esc(t(viewAs ? 'da_viewas' : 'da_no_perm'))}</p>`
      : !openForm ? `<button type="button" class="b2b-btn b2b-btn--secondary" id="bpBfOpen">${esc(t('da_edit'))}</button>`
      : `<form class="bp-bf-form" id="bpBfForm" novalidate aria-labelledby="bpBfFormTitle">
          <h3 class="bp-h3" id="bpBfFormTitle">${esc(t('da_form'))}</h3>
          <p class="bp-note">${esc(t('da_req_note'))}</p>
          <div class="bp-bf-grid">${BF.map((f) => billingField(f, pre[f[0]])).join('')}</div>
          <p class="bp-bf-summary" id="bpBfSummary" role="alert" hidden></p>
          <div class="bp-actions">
            <button type="submit" class="b2b-btn b2b-btn--primary" id="bpBfSend">${esc(t(reqRow && reqRow.status === 'PENDING' ? 'da_submit_again' : 'da_submit'))}</button>
            ${S.billOpen === S.companyId && !(st && st.incomplete) && !(reqRow && reqRow.status === 'PENDING') ? `<button type="button" class="b2b-btn b2b-btn--ghost" id="bpBfCancel">${esc(t('da_cancel'))}</button>` : ''}
          </div>
        </form>`;
    MAIN.innerHTML = `
      ${h1(t('p_details'), esc(t('da_sub')))}
      <section class="bp-section"><dl class="bp-facts bp-facts--stack">
        <div><dt>${esc(t('p_company'))}</dt><dd>${esc(co.name)}</dd></div>
        ${groupOfCompany(S.company) ? `<div><dt>${esc(t('p_group'))}</dt><dd>${esc(groupOfCompany(S.company).name)}</dd></div>` : ''}
      </dl></section>
      <section class="bp-section" aria-labelledby="bpBf"><h2 class="bp-h2" id="bpBf">${esc(t('da_billing'))}</h2>
        ${status}
        <h3 class="bp-h3">${esc(t('da_current'))}</h3>
        ${officialHtml(off)}
        ${form}
      </section>
      <section class="bp-section" aria-labelledby="bpSt"><h2 class="bp-h2" id="bpSt">${esc(t('da_stores'))}</h2>
        <ul class="bp-list" role="list">${stores.map((s) => `<li class="bp-row bp-row--static"><span class="bp-row-main"><strong>${esc(s.name)}</strong>
          <span class="bp-row-meta">${esc(s.country_code ? B.countryName(s.country_code) : t('da_no_country'))}</span></span></li>`).join('')}</ul>
      </section>
      <section class="bp-section" aria-labelledby="bpAcc"><h2 class="bp-h2" id="bpAcc">${esc(t('da_access'))}</h2>
        <dl class="bp-facts bp-facts--stack">
          <div><dt>${esc(t('da_user'))}</dt><dd>${esc((S.session.user && S.session.user.email) || '')}</dd></div>
          <div><dt>${esc(t('da_can_order'))}</dt><dd>${esc(yn(S.company.can_order))}</dd></div>
          <div><dt>${esc(t('da_can_docs'))}</dt><dd>${esc(yn(S.company.can_see_documents))}</dd></div>
        </dl>
      </section>
      <a class="b2b-btn b2b-btn--secondary" href="${esc(mail)}">${esc(t('da_write'))}</a>`;
    wireBillingForm(seq, reqRow);
    if (S.billFocus) { S.billFocus = false; const s2 = MAIN.querySelector('#bpBfStatus'); if (s2) { s2.focus({ preventScroll: false }); return; } }
    focusMain();
  }

  function wireBillingForm(seq, reqRow) {
    const open = MAIN.querySelector('#bpBfOpen');
    if (open) open.addEventListener('click', () => { S.billOpen = S.companyId; viewDetails(S.renderSeq).then(() => { const f = MAIN.querySelector('#bf_legal_name'); if (f) f.focus(); }); });
    const cancel = MAIN.querySelector('#bpBfCancel');
    if (cancel) cancel.addEventListener('click', () => { S.billOpen = null; viewDetails(S.renderSeq).then(() => { const b = MAIN.querySelector('#bpBfOpen'); if (b) b.focus(); }); });
    const form = MAIN.querySelector('#bpBfForm');
    if (!form) return;
    // al corregir un campo marcado, se quita la marca
    form.addEventListener('input', (e) => { const f = e.target.closest('[data-bf]'); if (f && f.classList.contains('is-invalid')) markField(form, f.dataset.bf, null); });
    form.addEventListener('change', (e) => { const f = e.target.closest('[data-bf]'); if (f && f.classList.contains('is-invalid')) markField(form, f.dataset.bf, null); });
    form.addEventListener('submit', (e) => { e.preventDefault(); sendBilling(form); });
  }

  function markField(form, k, code) {
    const box = form.querySelector(`[data-bf="${k}"]`);
    if (!box) return;
    const input = box.querySelector('input,select');
    const err = box.querySelector('.bp-bf-err');
    const hint = box.querySelector('.bp-bf-hint');
    box.classList.toggle('is-invalid', !!code);
    err.hidden = !code;
    err.textContent = code ? t('da_err_' + code) : '';
    if (code) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    const ids = [hint ? hint.id : null, code ? err.id : null].filter(Boolean);
    if (ids.length) input.setAttribute('aria-describedby', ids.join(' ')); else input.removeAttribute('aria-describedby');
  }

  function showErrors(form, errs, message) {
    B.billing.FIELDS.forEach((k) => markField(form, k, errs[k] || null));
    const sum = form.querySelector('#bpBfSummary');
    const keys = B.billing.FIELDS.filter((k) => errs[k]);
    sum.hidden = !keys.length && !message;
    sum.textContent = message || (keys.length ? t('da_err_summary') : '');
    const first = keys.length ? form.querySelector('#bf_' + keys[0]) : null;
    if (first) first.focus();
  }

  async function sendBilling(form) {
    const raw = {};
    B.billing.FIELDS.forEach((k) => { const el = form.elements[k]; raw[k] = el ? el.value : ''; });
    const details = B.billing.normalizeDetails(raw);
    const errs = B.billing.validateDetails(details);
    if (Object.keys(errs).length) { showErrors(form, errs); return; }
    showErrors(form, {});
    // misma clave mientras se reintenta el mismo envío; otra si cambian los datos
    const fp = JSON.stringify(details);
    if (!S.billAttempt || S.billAttempt.fp !== fp || S.billAttempt.company !== S.companyId) S.billAttempt = { fp, company: S.companyId, key: B.uuid() };
    const btn = form.querySelector('#bpBfSend');
    busy(btn, true);
    const companyId = S.companyId;
    const r = await B.rpc('portal_submit_company_details', { p_company: companyId, p_details: details, p_key: S.billAttempt.key });
    busy(btn, false);
    if (r.error) {
      if (r.code === 'session_expired') { await B.signOut(); return; }
      const fields = String(r.detail || '').split(',').map((x) => x.trim()).filter((x) => B.billing.FIELDS.includes(x));
      const code = r.code === 'missing_fields' ? 'required' : 'format';
      showErrors(form, Object.fromEntries(fields.map((k) => [k, code])), B.errorMessage(r.code));
      return;
    }
    S.billAttempt = null;
    S.billOpen = null;
    const d = r.data || {};
    B.billing.setRequest(companyId, { id: d.request_id, company_id: companyId, status: d.status || 'PENDING', version: d.version,
      details, submitted_at: d.submitted_at || new Date().toISOString(), ses_note: null, resolved_at: null });
    if (companyId !== S.companyId || S.route.name !== 'details') return;
    S.billFocus = true;
    B.toast(t('da_received'), 'ok', { root: ROOT });
    await viewDetails(S.renderSeq);
  }

  // grupo del que es administrador y al que pertenece la empresa (los compradores no ven el grupo)
  function groupOfCompany(c) {
    return c && c.group_id ? myGroups().find((g) => g.id === c.group_id) || null : null;
  }

  // Datos en la vista de grupo: el grupo, sus hoteles (empresa, NIF, tiendas) y los permisos del usuario.
  async function viewGroupDetails(seq) {
    const list = scopeCompanies();
    const rows = await guard(async () => (list.length ? q(() => sb().from('portal_companies')
      .select('id,name,legal_name,tax_id').in('id', list.map((c) => c.id)).order('name')) : []), render);
    if (!rows || stale(seq)) return;
    const byId = new Map(rows.map((r) => [r.id, r]));
    const yn = (v) => (v ? t('da_yes') : t('da_no'));
    const g = S.group;
    const mail = `mailto:antonio@sespalma.com?subject=${encodeURIComponent('Cambio de datos · ' + (g.name || ''))}`;
    MAIN.innerHTML = `
      ${h1(t('p_details'), esc(t('da_readonly')))}
      <section class="bp-section"><dl class="bp-facts bp-facts--stack">
        <div><dt>${esc(t('p_group'))}</dt><dd>${esc(g.name)}</dd></div>
      </dl></section>
      <section class="bp-section" aria-labelledby="bpHot"><h2 class="bp-h2" id="bpHot">${esc(t('g_hotels'))}</h2>
        <ul class="bp-list" role="list">${list.map((c) => {
          const co = byId.get(c.id) || c;
          const legal = [co.legal_name && co.legal_name !== co.name ? co.legal_name : '', co.tax_id || ''].filter(Boolean).join(' · ');
          const stores = (c.stores || []).map((st) => `${st.name}${st.country_code ? ' · ' + B.countryName(st.country_code) : ''}`).join(', ');
          return `<li class="bp-row bp-row--static"><span class="bp-row-main"><strong>${esc(co.name)}</strong>
            ${legal ? `<span class="bp-row-meta u-tnum">${esc(legal)}</span>` : ''}
            ${stores ? `<span class="bp-row-meta">${esc(stores)}</span>` : ''}</span></li>`;
        }).join('')}</ul>
      </section>
      <section class="bp-section" aria-labelledby="bpAcc"><h2 class="bp-h2" id="bpAcc">${esc(t('da_access'))}</h2>
        <p class="bp-note">${esc(t('da_group_access'))}</p>
        <dl class="bp-facts bp-facts--stack">
          <div><dt>${esc(t('da_user'))}</dt><dd>${esc((S.session.user && S.session.user.email) || '')}</dd></div>
          <div><dt>${esc(t('da_can_order'))}</dt><dd>${esc(yn(g.can_order))}</dd></div>
          <div><dt>${esc(t('da_can_docs'))}</dt><dd>${esc(yn(g.can_see_documents))}</dd></div>
        </dl>
      </section>
      <a class="b2b-btn b2b-btn--secondary" href="${esc(mail)}">${esc(t('da_change'))}</a>`;
    focusMain();
  }

  /* ---------- bandeja de SES (admin) ---------- */
  async function viewAdmin(seq) {
    const rows = await guard(async () => {
      const reqs = await q(() => sb().from('portal_requests')
        .select('id,ref,company_id,season,status,turn,current_version,updated_at,portal_companies(name)')
        .neq('status', 'DRAFT').order('updated_at', { ascending: false }).limit(300));
      const ids = reqs.filter((r) => r.current_version > 0).map((r) => r.id);
      const vs = ids.length ? await q(() => sb().from('portal_request_versions').select('request_id,version,units,total,currency').in('request_id', ids)) : [];
      reqs.forEach((r) => {
        const v = vs.find((x) => x.request_id === r.id && x.version === r.current_version);
        r.units = v ? v.units : null; r.total = v ? v.total : null; r.currency = v ? v.currency : 'EUR';
        r.company_name = r.portal_companies ? r.portal_companies.name : '';
      });
      return reqs;
    }, render);
    if (!rows || stale(seq)) return;
    const ses = rows.filter((r) => r.turn === 'SES' && ['SUBMITTED', 'COUNTER'].includes(r.status))
      .sort((a, b) => String(a.updated_at).localeCompare(String(b.updated_at)));
    const buyer = rows.filter((r) => r.turn === 'BUYER' && r.status === 'CHANGES_PROPOSED');
    const done = rows.filter((r) => ['APPROVED', 'CANCELLED'].includes(r.status)).slice(0, 20);
    const group = (id, title, list, emptyTxt) => `
      <section class="bp-section" aria-labelledby="${id}">
        <h2 class="bp-h2" id="${id}">${esc(title)} <span class="bp-count u-tnum">${list.length}</span></h2>
        ${list.length ? `<ul class="bp-list" role="list">${list.map(requestRow).join('')}</ul>` : empty(emptyTxt)}
      </section>`;
    MAIN.innerHTML = `${h1(t('ad_title'))}
      ${group('bpAdSes', t('ad_ses'), ses, t('ad_empty'))}
      ${group('bpAdBuyer', t('ad_buyer'), buyer, t('ad_empty'))}
      ${done.length ? group('bpAdDone', t('ad_done'), done, '') : ''}`;
    focusMain();
  }

  boot();
})();
